<template>
  <ion-app :class="{ 'app-desktop-layout': useDesktopLayout }">
    <ion-fab :horizontal="menuButton.position === 'left' ? 'start' : 'end'" vertical="top" slot="fixed"
      v-show="showMainMenuFab">
      <ion-fab-button @click="openMenu()" class="menu-fab-button">
        <div class="menu-notification-flag" v-show="globalContext.showMenuNotification && menuButton.position !== 'left'
          "></div>
        <ion-icon :icon="menuOutline" class="app-icon"></ion-icon>
        <div class="menu-notification-flag" v-show="globalContext.showMenuNotification && menuButton.position == 'left'
          "></div>
      </ion-fab-button>
    </ion-fab>

    <ion-split-pane content-id="main" :when="splitPaneWhen">
    <ion-menu contentId="main" menuId="mainMenu" :side="menuButton.position === 'left' ? 'start' : 'end'"
      :swipe-gesture="false">
      <div class="menu-header-background menu-header menu-header-modern">
        <img
          :src="menuHeaderLogoSrc"
          alt=""
          aria-hidden="true"
          class="menu-header-logo-bg"
          :class="{ 'menu-header-logo-bg--light': effectiveTheme === 'light' }"
        />
        <button
          v-if="useDesktopLayout"
          type="button"
          class="menu-collapse-btn"
          aria-label="Свернуть меню"
          title="Свернуть меню"
          @click="setDesktopMenuCollapsed(true)"
        >
          <ion-icon :icon="chevronBackOutline" aria-hidden="true" />
        </button>
        <template v-if="isAuthenticated">
          <button
            type="button"
            class="menu-header-profile-row"
            @click="canShowSection('ACCOUNT') && navigate('account')"
            :disabled="!canShowSection('ACCOUNT')"
          >
            <ion-avatar class="menu-header-avatar">
              <ion-img :src="avatarUrl" v-show="avatarUrl !== ''"></ion-img>
              <img src="@/theme/fencer-2.png" v-show="avatarUrl == ''" alt="" />
            </ion-avatar>
            <div class="menu-header-profile-text">
              <ion-label v-if="menuUserDisplayName" class="menu-header-user-label">{{ menuUserDisplayName }}</ion-label>
              <span class="menu-header-profile-link">
                Профиль
                <ion-icon :icon="chevronForwardOutline" class="menu-header-profile-chevron" aria-hidden="true" />
              </span>
            </div>
          </button>
        </template>
        <div v-else class="menu-header-guest-actions">
          <ion-button expand="block" class="menu-header-login-btn" @click="navigate('login')">Вход</ion-button>
        </div>
      </div>
      <ion-content class="menu-content">
        <ion-list class="menu-list">
          <ion-item @click="navigate('showcase')" :class="[isShowcase ? 'selected-route' : '', 'menu-item']">
            <ion-icon :icon="homeOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Главная</ion-label>
          </ion-item>
          <ion-item @click="navigate('programs')" :class="[isPrograms ? 'selected-route' : '', 'menu-item']" v-if="canShowSection('PROGRAMS')">
            <ion-icon :icon="fileTrayFullOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Релизы от Лиги</ion-label>
          </ion-item>
          <ion-item @click="navigate('music-library')" :class="[isMusicLibrary ? 'selected-route' : '', 'menu-item']" v-if="canShowMusicLibrary()">
            <ion-icon :icon="discOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Музыка</ion-label>
          </ion-item>
          <ion-item @click="navigate('playlist-list')" :class="[isPlaylistList ? 'selected-route' : '', 'menu-item']"
            v-if="canShowSection('PLAYLIST_LIST')">
            <ion-icon :icon="musicalNotesOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Миксы</ion-label>
          </ion-item>
          <ion-item @click="navigate('skills')" :class="[isSkills ? 'selected-route' : '', 'menu-item']"  v-if="canShowSection('TRAININGS')">
            <ion-icon :icon="folderOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Тренинги</ion-label>
          </ion-item>
          <ion-item @click="navigate('exercises')" :class="[isExercises ? 'selected-route' : '', 'menu-item']"  v-if="canShowSection('EXERCISES')">
            <ion-icon :icon="folderOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Упражнения</ion-label>
          </ion-item>
          <ion-item @click="navigate('workouts')" :class="[isWorkouts ? 'selected-route' : '', 'menu-item']"  v-if="canShowSection('WORKOUTS')">
            <ion-icon :icon="folderOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Тренировки</ion-label>
          </ion-item>
          <ion-item @click="navigate('education')" :class="[isEducation ? 'selected-route' : '', 'menu-item']"  v-if="canShowSection('EDUCATION')">
            <ion-icon :icon="folderOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Образование</ion-label>
          </ion-item>
          <ion-item @click="navigate('testing')" :class="[isTesting ? 'selected-route' : '', 'menu-item']" v-if="canShowSection('TESTING') && !globalContext.offlineMode">
            <ion-icon :icon="documentTextOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Тестирование</ion-label>
          </ion-item>
          <ion-item @click="navigate('events')" :class="[isEvents ? 'selected-route' : '', 'menu-item']" v-if="canShowSection('EVENTS')">
            <ion-icon :icon="calendarOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">События</ion-label>
          </ion-item>
          <ion-item @click="navigate('useful-links')" :class="[isUsefulLinks ? 'selected-route' : '', 'menu-item']" v-if="canShowSection('USEFUL_LINKS')">
            <ion-icon :icon="linkOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Полезные ссылки</ion-label>
          </ion-item>
          <ion-item @click="navigate('my-tickets')" :class="[isMyTickets ? 'selected-route' : '', 'menu-item']" v-if="canShowSection('MY_TICKETS')">
            <ion-icon :icon="ticketOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Мои билеты</ion-label>
          </ion-item>
          <ion-item @click="navigate('my-subscriptions')" :class="[isMySubscriptions ? 'selected-route' : '', 'menu-item']" v-if="canShowSection('MY_SUBSCRIPTIONS')">
            <ion-icon :icon="ribbonOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Мои подписки</ion-label>
          </ion-item>
          <ion-item @click="navigate('messenger')" :class="[isMessenger ? 'selected-route' : '', 'menu-item']" v-if="canShowSection('MESSENGER') && isAuthenticated">
            <ion-icon :icon="chatbubbleEllipsesOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Liga.Chat</ion-label>
            <span v-if="messengerUnreadLabel" slot="end" class="ios-unread-badge ios-unread-badge--list">{{ messengerUnreadLabel }}</span>
          </ion-item>
          <ion-item-divider v-if="hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGER']) && isAuthenticated">
            <ion-label class="menu-section-label">Администрирование</ion-label>
          </ion-item-divider>
          <ion-item @click="navigate('users')" :class="[isUsers ? 'selected-route' : '', 'menu-item']"
            v-if="hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGER']) && isAuthenticated">
            <ion-icon :icon="peopleOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Пользователи</ion-label>
          </ion-item>
          <ion-item @click="navigate('admin-roles')" :class="[isAdminRoles ? 'selected-route' : '', 'menu-item']"
            v-if="hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGER']) && isAuthenticated">
            <ion-icon :icon="keyOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Роли</ion-label>
          </ion-item>
          <ion-item @click="navigate('admin-app-sections')" :class="[isAdminAppSections ? 'selected-route' : '', 'menu-item']"
            v-if="hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGER']) && isAuthenticated">
            <ion-icon :icon="apps" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Разделы приложения</ion-label>
          </ion-item>
          <ion-item @click="navigate('admin-education-sections')" :class="[isAdminEducationSections ? 'selected-route' : '', 'menu-item']"
            v-if="hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGER']) && isAuthenticated">
            <ion-icon :icon="libraryOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Разделы медиатеки</ion-label>
          </ion-item>
          <ion-item @click="navigate('admin-media-upload')" :class="[isAdminMediaUpload ? 'selected-route' : '', 'menu-item']"
            v-if="hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGER']) && isAuthenticated">
            <ion-icon :icon="cloudUploadOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Медиатека</ion-label>
          </ion-item>
          <ion-item @click="navigate('admin-releases')" :class="[isAdminReleases ? 'selected-route' : '', 'menu-item']"
            v-if="hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGER']) && isAuthenticated">
            <ion-icon :icon="fileTrayFullOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Релизы</ion-label>
          </ion-item>
          <ion-item @click="navigate('admin-conversion-queue')" :class="[isAdminConversionQueue ? 'selected-route' : '', 'menu-item']"
            v-if="hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGER']) && isAuthenticated">
            <ion-icon :icon="listOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Очередь конвертации</ion-label>
          </ion-item>
          <ion-item @click="navigate('admin-library-music')" :class="[isAdminLibraryMusic ? 'selected-route' : '', 'menu-item']"
            v-if="hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGER']) && isAuthenticated">
            <ion-icon :icon="discOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Каталог музыки</ion-label>
          </ion-item>
          <ion-item @click="navigate('admin-media-stats')" :class="[isAdminMediaStats ? 'selected-route' : '', 'menu-item']"
            v-if="hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGER']) && isAuthenticated">
            <ion-icon :icon="statsChartOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Статистика медиа</ion-label>
          </ion-item>
          <ion-item @click="navigate('admin-subscriptions')" :class="[isAdminSubscriptions ? 'selected-route' : '', 'menu-item']"
            v-if="hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGER']) && isAuthenticated">
            <ion-icon :icon="ribbonOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Подписки (админ)</ion-label>
          </ion-item>
          <ion-item @click="navigate('admin-subscription-purchases')" :class="[isAdminSubscriptionPurchases ? 'selected-route' : '', 'menu-item']"
            v-if="hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGER']) && isAuthenticated">
            <ion-icon :icon="ticketOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Подписки (пользователи)</ion-label>
          </ion-item>
          <ion-item @click="navigate('admin-promo-codes')" :class="[isAdminPromoCodes ? 'selected-route' : '', 'menu-item']"
            v-if="hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGER']) && isAuthenticated">
            <ion-icon :icon="pricetagOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Промокоды</ion-label>
          </ion-item>
          <ion-item @click="navigate('admin-returns')" :class="[isAdminReturns ? 'selected-route' : '', 'menu-item']"
            v-if="hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGER']) && isAuthenticated">
            <ion-icon :icon="returnDownBackOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Возвраты</ion-label>
            <ion-badge v-if="returnsPendingCount > 0" slot="end" color="warning" class="menu-returns-badge">
              {{ returnsPendingCount }}
            </ion-badge>
          </ion-item>
          <ion-item @click="navigate('admin-payments')" :class="[isAdminPayments ? 'selected-route' : '', 'menu-item']"
            v-if="hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGER']) && isAuthenticated">
            <ion-icon :icon="cardOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Оплаты</ion-label>
          </ion-item>
          <ion-item @click="navigate('admin-useful-links')" :class="[isAdminUsefulLinks ? 'selected-route' : '', 'menu-item']"
            v-if="hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGER']) && isAuthenticated">
            <ion-icon :icon="linkOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Полезные ссылки (админ)</ion-label>
          </ion-item>
          <ion-item @click="navigate('admin-testing')" :class="[isAdminTesting ? 'selected-route' : '', 'menu-item']"
            v-if="hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGER']) && isAuthenticated && !globalContext.offlineMode">
            <ion-icon :icon="documentTextOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Тестирование</ion-label>
          </ion-item>
          <ion-item @click="openSupportChannelMenu()" class="menu-item" v-if="canShowSection('SUPPORT') && !globalContext.offlineMode">
            <ion-icon :icon="helpOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Техподдержка</ion-label>
          </ion-item>
          <ion-item @click="navigate('settings')" :class="[isSettings ? 'selected-route' : '', 'menu-item']" v-if="canShowSection('SETTINGS')">
            <ion-icon :icon="settingsOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Настройки</ion-label>
          </ion-item>
        </ion-list>
      </ion-content>
      <ion-footer class="menu-footer">
        <ion-toolbar translucent class="app-footer-style">
          <!-- Юридический блок только в десктопном split-pane; в мобильной вёрстке — в Настройках -->
          <template v-if="useDesktopLayout">
            <div class="menu-footer-links">
              <a :href="LEGAL.offerUrl" target="_blank" rel="noopener noreferrer" class="menu-footer-link">Оферта</a>
              <span class="menu-footer-sep">|</span>
              <span @click="navigate('privacy-policy')" class="menu-footer-link">Конфиденциальность</span>
              <span class="menu-footer-sep">|</span>
              <span @click="navigate('offer-supplement')" class="menu-footer-link">Возвраты</span>
            </div>
            <p class="menu-footer-payee">Платежи принимает: <a :href="LEGAL.offerUrl" target="_blank" rel="noopener noreferrer" class="menu-footer-link">{{ LEGAL.payeeShortName }}</a></p>
          </template>
          <ion-title class="ion-text-center menu-footer menu-footer-version" @click="checkAppUpdate()">Версия {{ appVersion }}</ion-title>
        </ion-toolbar>
      </ion-footer>
    </ion-menu>

    <div id="main" class="app-main-shell">
    <ion-tabs>
      <ion-router-outlet></ion-router-outlet>

      <div :class="['music-player-container', !showReleaseTabs() && !showMainTabs() ? 'music-player-bottom-container' : '', useDesktopLayout ? 'music-player-desktop' : '']" v-show="playerBar.visible && !playerBar.microMode">
        <audio ref="audioRef" preload="metadata" v-if="!isMobile">
          <source :src="trackPath" type="audio/mpeg" />
        </audio>

        <div class="w-player" v-show="!showPlayList">
          <div class="w-track-name">
            {{
              playerBar.currentTrackIdx !== undefined &&
              playerBar.musicList !== undefined &&
              playerBar.musicList[playerBar.currentTrackIdx] !== undefined
              ? mediaUtils.getTrackName(
                playerBar.musicList[playerBar.currentTrackIdx]
              )
              : ""
            }}
          </div>
          <div class="w-playlist-name">
            {{ playerBar.playlistName }}
          </div>
          <div class="w-player-range">
            <vue-slider :lazy="true" v-model="playerBar.currentPosition" :min="0" :max="playerBar.currentDuration"
              @dragging="rangeDragging" @dragStart="rangeDragStart()" @dragEnd="rangeDragEnd()" tooltip="none"
              :drag-on-click="true">
            </vue-slider>
          </div>
          <div class="player-label player-current-time">
            {{ playerBar.currentTrackCurrentTime }}
          </div>
          <div class="player-label player-total-time">
            {{
              playerBar.musicList && playerBar.musicList.length > 0
              ? mediaUtils.formatTime(
                playerBar.musicList[playerBar.currentTrackIdx].duration -
                playerBar.currentPosition
              )
              : "--:--"
            }}
          </div>
          <div class="w-player-buttons">
            <ion-button class="player-button player-extended-sm-button" :disabled="isFM()" @click="prevAudioTrack()">
              <ion-icon :icon="playSkipBack" class="player-button-icon"></ion-icon>
            </ion-button>
            <ion-button class="player-button player-extended-sm-button" :disabled="isFM()" @click="playBackTrack()">
              <ion-icon :icon="playBack" class="player-button-icon"></ion-icon>
            </ion-button>
            <ion-button class="player-button" @click="changeCurrentPosition(-15)">
              -15
            </ion-button>
            <ion-button class="player-button player-extended-l-button" slot="end"
              @click="playerControls(!playerBar.playing)">
              <ion-icon :icon="play" class="player-button-icon"
                v-show="!playerBar.playing && (!isMobile || playerBar.isReady)"></ion-icon>
              <ion-icon :icon="pause" class="player-button-icon"
                v-show="playerBar.playing && (!isMobile || playerBar.isReady)"></ion-icon>
              <ion-spinner name="bubbles" v-show="isMobile && !playerBar.isReady"></ion-spinner>
            </ion-button>
            <ion-button class="player-button" @click="changeCurrentPosition(15)">
              +15
            </ion-button>
            <ion-button class="player-button player-extended-sm-button" @click="nextAudioTrack()">
              <ion-icon :icon="playSkipForward" class="player-button-icon"></ion-icon>
            </ion-button>
          </div>
          <div class="w-service-player-buttons">
            <ion-button class="player-button" @click="extendPlayerOnTrackName()" :disabled="isFM()">
              <ion-icon :icon="menuOutline" class="player-button-icon"></ion-icon>
            </ion-button>
            <ion-button class="player-button" @click="toMicroMode()" v-show="false">
              <ion-icon :icon="contractOutline" class="player-button-icon"></ion-icon>
            </ion-button>
            <ion-button class="player-button" @click="closePlayer()">
              <ion-icon :icon="closeOutline" class="player-button-icon"></ion-icon>
            </ion-button>
          </div>
      </div>

        <transition name="playlist-player">
          <div class="w-full-player" v-show="showPlayList && !isFM()">
            <div class="w-full-player-header">
              <ion-button class="playlist-collapse-button" @click="toExtendedPlayer()">
                <ion-icon :icon="chevronDownOutline" class="player-button-icon"></ion-icon>
              </ion-button>
              <img :src="playerAlbumImage" v-if="playerBar.fixedAlbumArtUrl || (playerBar.playlistImage && '' !== playerBar.playlistImage)
                " />
              <div class="playlist-header-text-wrapper">
                <p>
                  {{ playerBar.musicList.length }} Треков &#183;
                  {{
                    mediaUtils.formatTime(
                      mediaUtils.getTotalPlaylistDuration(playerBar.musicList)
                    )
                  }}
                  /
                  <span class="orange-regular">{{
                    mediaUtils.formatTime(
                      mediaUtils.getTotalPlaylistDurationFromIndex(
                        playerBar.musicList,
                        playerBar.currentTrackIdx
                      ) - playerBar.currentPosition
                    )
                  }}</span>
                </p>
                <h1>
                  {{
                    playerBar.currentTrackIdx !== undefined &&
                    playerBar.musicList !== undefined &&
                    playerBar.musicList[playerBar.currentTrackIdx] !==
                    undefined
                    ? mediaUtils.getTrackNameShort(
                      playerBar.musicList[playerBar.currentTrackIdx]
                    )
                    : ""
                  }}
                </h1>
                <h3>
                  {{ playerBar.playlistName }}
                </h3>

                <div class="playlist-play-button-wrapper">
                  <ion-button class="playlist-play-button" @click="playerControls(!playerBar.playing)">
                    <ion-icon :icon="play" class="player-button-icon"
                      v-show="!playerBar.playing && playerBar.isReady"></ion-icon>
                    <ion-icon :icon="pause" class="player-button-icon"
                      v-show="playerBar.playing && playerBar.isReady"></ion-icon>
                    <ion-spinner name="bubbles" v-show="!playerBar.isReady"></ion-spinner>
                  </ion-button>
                  <ion-button class="playlist-play-button playlist-play-button-sm" @click="prevAudioTrack()">
                    <ion-icon :icon="playSkipBack" class="player-button-icon"></ion-icon>
                  </ion-button>
                  <ion-button class="playlist-play-button playlist-play-button-sm" @click="playBackTrack()" v-if="false">
                    <ion-icon :icon="playBack" class="player-button-icon"></ion-icon>
                  </ion-button>
                  <ion-button class="playlist-play-button playlist-play-button-sm" @click="nextAudioTrack()">
                    <ion-icon :icon="playSkipForward" class="player-button-icon"></ion-icon>
                  </ion-button>
                </div>
              </div>
            </div>
            <div class="w-full-player-range">
              <div class="player-label playlist-current-time">
                {{ playerBar.currentTrackCurrentTime }}
              </div>
              <div class="player-label playlist-total-time">
                {{
                  playerBar.musicList && playerBar.musicList.length > 0
                      ? mediaUtils.formatTime(
                          playerBar.musicList[playerBar.currentTrackIdx]
                              .duration - playerBar.currentPosition
                      )
                      : "--:--"
                }}
              </div>
              <div class="player-range player-playlist-range">
                <vue-slider :lazy="true" v-model="playerBar.currentPosition" :min="0" :max="playerBar.currentDuration"
                            @dragging="rangeDragging" @dragStart="rangeDragStart()" @dragEnd="rangeDragEnd()" tooltip="none"
                            :drag-on-click="true">
                </vue-slider>
              </div>
            </div>
            <ion-list class="player-playlist" lines="none">
              <ion-item v-for="(audioTrack, idx) in playerBar.musicList" :key="audioTrack.id"
                @click="selectTrackAndPlay(idx)" class="player-item">
                <ion-label :class="[
                  playerBar.currentTrackIdx === idx ? 'selected-track' : '',
                  'playlist-label',
                ]">{{ mediaUtils.getTrackNameShort(audioTrack) }}</ion-label>
                <ion-note :class="[
                  playerBar.currentTrackIdx === idx ? 'selected-track' : '',
                ]" slot="end">{{ mediaUtils.formatTime(audioTrack.duration) }}</ion-note>
              </ion-item>
            </ion-list>
            <ion-item class="fake-footer bg-transparent" lines="none">
            </ion-item>
          </div>
        </transition>
      </div>

      <div :class="['micro-player-container', playerBar.microExtendedMode ? 'micro-player-container-ext' : '']" v-show="playerBar.microMode && playerBar.musicList.length > 0">
        <div class="micro-player">
          <div :class="['w-track-index', playerBar.microExtendedMode ? 'w-track-index-ext' : '']" @click="playerBar.microExtendedMode = !playerBar.microExtendedMode">
            {{ playerBar.currentTrackIdx + 1 }}
            <div class="micro-track-time">
              {{ playerBar.currentTrackCurrentTime }}
            </div>
          </div>
          <div class="micro-player-controls" v-show="playerBar.microExtendedMode">
            <div class="micro-player-buttons">
              <ion-button class="player-button player-extended-sm-button" :disabled="isFM()" @click="prevAudioTrack()">
                <ion-icon :icon="playSkipBack" class="player-button-icon"></ion-icon>
              </ion-button>
              <ion-button class="player-button player-extended-sm-button" :disabled="isFM()" @click="playBackTrack()">
                <ion-icon :icon="playBack" class="player-button-icon"></ion-icon>
              </ion-button>
              <ion-button class="player-button" @click="changeCurrentPosition(-15)">
                -15
              </ion-button>
              <ion-button class="player-button player-extended-l-button" slot="end"
                          @click="playerControls(!playerBar.playing)">
                <ion-icon :icon="play" class="player-button-icon"
                          v-show="!playerBar.playing && (!isMobile || playerBar.isReady)"></ion-icon>
                <ion-icon :icon="pause" class="player-button-icon"
                          v-show="playerBar.playing && (!isMobile || playerBar.isReady)"></ion-icon>
                <ion-spinner name="bubbles" v-show="isMobile && !playerBar.isReady"></ion-spinner>
              </ion-button>
              <ion-button class="player-button" @click="changeCurrentPosition(15)">
                +15
              </ion-button>
              <ion-button class="player-button player-extended-sm-button" @click="nextAudioTrack()">
                <ion-icon :icon="playSkipForward" class="player-button-icon"></ion-icon>
              </ion-button>
            </div>
          </div>
          <div class="player-range micro-range">
            <vue-slider :lazy="true" v-model="playerBar.currentPosition" :min="0" :max="playerBar.currentDuration"
                        @dragging="rangeDragging" @dragStart="rangeDragStart()" @dragEnd="rangeDragEnd()" tooltip="none"
                        :drag-on-click="true" :dotSize="playerBar.microExtendedMode ? 8 : 5">
            </vue-slider>
          </div>
        </div>
      </div>

      <ion-modal ref="playNowModal" @didDismiss="() => {
          showPlayNow = false;
        }
        " :can-dismiss="true" :breakpoints="[0.5, 0.8, 1]" :initialBreakpoint="0.5" :is-open="showPlayNow"
        :handle="false" class="play-now-container">
        <ion-content>
          <div>
            <ion-button @click="playNowNavigate('programs')">
              <ion-label>Релизы от Лиги</ion-label>
            </ion-button>
            <ion-button v-show="isMobile" @click="playNowNavigate('playlist-list')">
              <ion-label>Миксы</ion-label>
            </ion-button>
            <ion-button :disabled="playerBar.musicList.length < 1" @click="playNow()">
              <ion-label>Сейчас:
                {{
                  playerBar.playlistName.length > 0 ? playerBar.playlistName : "-"
                }}</ion-label>
            </ion-button>
            <ion-button @click="showPlayNow = false" class="cancel-button">
              <ion-label>
                Закрыть
              </ion-label>
            </ion-button>
          </div>
        </ion-content>
      </ion-modal>

      <ion-tab-bar slot="bottom" v-show="showReleaseTabs()" class="modern-tab-bar" :class="{ 'tab-bar-web': !isMobile }">
        <ion-tab-button class="modern-tab-button" @click="navigate('Programs')">
          <div class="tab-icon-wrapper">
            <ion-icon :icon="fileTrayFullOutline"></ion-icon>
          </div>
          <span class="tab-label">Назад</span>
        </ion-tab-button>
        <ion-tab-button tab="music" href="/music" target="release-router" class="modern-tab-button">
          <div class="tab-icon-wrapper">
            <ion-icon :icon="musicalNotesOutline"></ion-icon>
          </div>
          <span class="tab-label">Музыка</span>
        </ion-tab-button>
        <ion-tab-button tab="video" href="/video" target="release-router" class="modern-tab-button">
          <div class="tab-icon-wrapper">
            <ion-icon :icon="filmOutline"></ion-icon>
          </div>
          <span class="tab-label">Видео</span>
        </ion-tab-button>
        <ion-tab-button tab="guide" href="/guide" target="release-router" class="modern-tab-button">
          <div class="tab-icon-wrapper">
            <ion-icon :icon="documentOutline"></ion-icon>
          </div>
          <span class="tab-label">Гайды</span>
        </ion-tab-button>
      </ion-tab-bar>

      <ion-tab-bar slot="bottom" v-show="showMainTabs()" v-if="showBottomNav" class="modern-tab-bar" :class="{ 'tab-bar-web': !isMobile }">
        <ion-tab-button
          tab="showcase"
          href="/showcase"
          :class="[{ selected: isShowcase }, 'modern-tab-button']"
        >
          <div class="tab-icon-wrapper">
            <ion-icon :icon="homeOutline"></ion-icon>
          </div>
          <span class="tab-label">Главная</span>
        </ion-tab-button>
        <ion-tab-button
          tab="programs"
          href="/programs"
          v-if="canShowSection('PROGRAMS')"
          :class="[{ selected: isActive('programs') }, 'modern-tab-button']"
        >
          <div class="tab-icon-wrapper">
            <ion-icon :icon="listOutline"></ion-icon>
          </div>
          <span class="tab-label">Релизы</span>
        </ion-tab-button>
        
        <ion-tab-button
          tab="playlists"
          href="/playlist-list"
          v-if="canShowSection('PLAYLIST_LIST')"
          :class="[{ selected: isActive('playlists') }, 'modern-tab-button']"
        >
          <div class="tab-icon-wrapper">
            <ion-icon :icon="playOutline"></ion-icon>
          </div>
          <span class="tab-label">Миксы</span>
        </ion-tab-button>

        <ion-tab-button
          tab="music-library"
          href="/music-library"
          v-if="canShowMusicLibrary()"
          :class="[{ selected: isActive('music-library') }, 'modern-tab-button']"
        >
          <div class="tab-icon-wrapper">
            <ion-icon :icon="discOutline"></ion-icon>
          </div>
          <span class="tab-label">Музыка</span>
        </ion-tab-button>
      </ion-tab-bar>

    </ion-tabs>
    </div>
    </ion-split-pane>

    <button
      v-if="useDesktopLayout && desktopMenuCollapsed"
      type="button"
      class="desktop-menu-expand-btn"
      aria-label="Развернуть меню"
      title="Развернуть меню"
      @click="setDesktopMenuCollapsed(false)"
    >
      <ion-icon :icon="menuOutline" aria-hidden="true" />
    </button>

    <ion-menu contentId="main" menuId="offlineMenu" :side="menuButton.position === 'left' ? 'start' : 'end'"
      type="overlay" :swipe-gesture="false">
      <div class="menu-header-background menu-header menu-header-modern menu-header-offline">
        <img
          :src="menuHeaderLogoSrc"
          alt=""
          aria-hidden="true"
          class="menu-header-logo-bg"
          :class="{ 'menu-header-logo-bg--light': effectiveTheme === 'light' }"
        />
        <button
          type="button"
          class="menu-header-profile-row"
          @click="canShowSection('ACCOUNT') && navigate('account')"
          :disabled="!canShowSection('ACCOUNT')"
        >
          <ion-avatar class="menu-header-avatar">
            <ion-img :src="avatarUrl" v-show="avatarUrl !== ''"></ion-img>
            <img src="@/theme/fencer-2.png" v-show="avatarUrl == ''" alt="" />
          </ion-avatar>
          <div class="menu-header-profile-text">
            <ion-label v-if="menuUserDisplayName" class="menu-header-user-label">{{ menuUserDisplayName }}</ion-label>
            <span class="menu-header-profile-link">
              Профиль
              <ion-icon :icon="chevronForwardOutline" class="menu-header-profile-chevron" aria-hidden="true" />
            </span>
          </div>
        </button>
      </div>
      <ion-content class="menu-content">
        <ion-list class="menu-list">
          <ion-item @click="navigate('showcase')" :class="[isShowcase ? 'selected-route' : '', 'menu-item']">
            <ion-icon :icon="homeOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Главная</ion-label>
          </ion-item>
          <ion-item @click="navigate('programs')" :class="[isPrograms ? 'selected-route' : '', 'menu-item']" v-if="canShowSection('PROGRAMS')">
            <ion-icon :icon="fileTrayFullOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Релизы от Лиги</ion-label>
          </ion-item>
          <ion-item @click="navigate('music-library')" :class="[isMusicLibrary ? 'selected-route' : '', 'menu-item']" v-if="canShowMusicLibrary()">
            <ion-icon :icon="discOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Музыка</ion-label>
          </ion-item>
          <ion-item @click="navigate('playlist-list')" :class="[isPlaylistList ? 'selected-route' : '', 'menu-item']" v-if="canShowSection('PLAYLIST_LIST')">
            <ion-icon :icon="musicalNotesOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Миксы</ion-label>
          </ion-item>
          <ion-item @click="navigate('skills')" :class="[isSkills ? 'selected-route' : '', 'menu-item']" v-if="isMobile && canShowSection('TRAININGS')">
            <ion-icon :icon="folderOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Тренинги</ion-label>
          </ion-item>
          <ion-item @click="navigate('exercises')" :class="[isExercises ? 'selected-route' : '', 'menu-item']" v-if="isMobile && canShowSection('EXERCISES')">
            <ion-icon :icon="folderOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Упражнения</ion-label>
          </ion-item>
          <ion-item @click="navigate('workouts')" :class="[isWorkouts ? 'selected-route' : '', 'menu-item']" v-if="isMobile && canShowSection('WORKOUTS')">
            <ion-icon :icon="folderOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Тренировки</ion-label>
          </ion-item>
          <ion-item @click="navigate('education')" :class="[isEducation ? 'selected-route' : '', 'menu-item']" v-if="isMobile && canShowSection('EDUCATION')">
            <ion-icon :icon="folderOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Образование</ion-label>
          </ion-item>
          <ion-item @click="navigate('testing')" :class="[isTesting ? 'selected-route' : '', 'menu-item']" v-if="isMobile && canShowSection('TESTING') && !globalContext.offlineMode">
            <ion-icon :icon="documentTextOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Тестирование</ion-label>
          </ion-item>
          <ion-item @click="navigate('messenger')" :class="[isMessenger ? 'selected-route' : '', 'menu-item']" v-if="canShowSection('MESSENGER') && isAuthenticated && !globalContext.offlineMode">
            <ion-icon :icon="chatbubbleEllipsesOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Liga.Chat</ion-label>
            <span v-if="messengerUnreadLabel" slot="end" class="ios-unread-badge ios-unread-badge--list">{{ messengerUnreadLabel }}</span>
          </ion-item>
          <ion-item @click="openSupportChannelMenu()" class="menu-item" v-if="canShowSection('SUPPORT') && !globalContext.offlineMode">
            <ion-icon :icon="helpOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Техподдержка</ion-label>
          </ion-item>
          <ion-item @click="navigate('settings')" :class="[isSettings ? 'selected-route' : '', 'menu-item']"
            v-if="canShowSection('SETTINGS')">
            <ion-icon :icon="settingsOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Настройки</ion-label>
          </ion-item>
        </ion-list>
      </ion-content>
      <ion-footer class="menu-footer">
        <ion-toolbar translucent class="app-footer-style">
          <template v-if="useDesktopLayout">
            <div class="menu-footer-links">
              <a :href="LEGAL.offerUrl" target="_blank" rel="noopener noreferrer" class="menu-footer-link">Оферта</a>
              <span class="menu-footer-sep">|</span>
              <span @click="navigate('privacy-policy')" class="menu-footer-link">Конфиденциальность</span>
              <span class="menu-footer-sep">|</span>
              <span @click="navigate('offer-supplement')" class="menu-footer-link">Возвраты</span>
            </div>
            <p class="menu-footer-payee">Платежи принимает: <a :href="LEGAL.offerUrl" target="_blank" rel="noopener noreferrer" class="menu-footer-link">{{ LEGAL.payeeShortName }}</a></p>
          </template>
          <ion-title class="ion-text-center menu-footer menu-footer-version">Версия {{ appVersion }}</ion-title>
        </ion-toolbar>
      </ion-footer>
    </ion-menu>

    <!-- <BottomCustomMenu 
      @menu-click="openMenu"
      @center-click="centerAction"
      @settings-click="openSettings"
    /> -->

    <ion-toast cssClass="custom-toast" :is-open="lostNetwork" message="Пропал интернет. Переходим в оффлайн."
      :duration="1200" position="middle" color="dark" @didDismiss="openNetworkToast(false)">
    </ion-toast>

    <ion-modal css-class="liga-modal-loading" :is-open="globalContext.isLoading" :backdropDismiss="false">
      <div class="liga-loading-container">
        <div class="liga-loading-go-offline" @click="goOfflineAndStopLoading()">
          <ion-icon :icon="cloudOffline"></ion-icon>
        </div>
        <p class="liga-loading-header">Загрузка</p>
        <img :src="require(`@/theme/liga-logo-black.png`)" alt="loading image" />
        <p class="liga-loading-header">ПОГОДИ, ЩА ВСЕ БУДЕТ</p>
        <ion-spinner name="bubbles"></ion-spinner>
      </div>
    </ion-modal>

    <!-- Согласие с политикой (fixed overlay на всех платформах — без ion-modal) -->
    <div
      v-if="showPrivacyConsentModal"
      class="privacy-consent-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="privacy-consent-title"
    >
      <div class="privacy-consent-sheet">
        <header class="privacy-consent-header">
          <h2 id="privacy-consent-title" class="privacy-consent-title">Согласие с условиями</h2>
        </header>
        <div class="privacy-consent-body">
          <p class="privacy-consent-text">
            Национальная лига тренеров обрабатывает ваши персональные данные в соответствии с Политикой конфиденциальности
            и Договором оферты, в том числе данные, связанные с использованием Liga.Chat (переписка, настройки приватности,
            уведомления). Продолжая использовать приложение, вы подтверждаете согласие с этими документами.
          </p>
          <p>
            <a href="#" @click.prevent="openPrivacyPolicy()" class="privacy-consent-link">Политика конфиденциальности</a>
          </p>
          <p>
            <a :href="privacyOfferUrl" target="_blank" rel="noopener noreferrer" class="privacy-consent-link">Договор оферты</a>
          </p>
        </div>
        <footer class="privacy-consent-footer">
          <ion-button
            expand="block"
            class="privacy-consent-accept-btn"
            :disabled="privacyConsentAccepting"
            @click="acceptPrivacyConsent()"
          >
            {{ privacyConsentAccepting ? 'Сохранение…' : 'Принимаю' }}
          </ion-button>
        </footer>
      </div>
    </div>

    <!-- Выбор темы оформления (один раз после обновления) -->
    <ion-modal
      :is-open="showAppearancePickerModal"
      :backdrop-dismiss="true"
      class="appearance-picker-modal"
      @didDismiss="onAppearancePickerDismissed"
    >
      <ion-header class="ion-no-border">
        <ion-toolbar>
          <ion-title>Выберите тему</ion-title>
          <ion-buttons slot="end">
            <ion-button fill="clear" class="appearance-picker-header-later" @click="dismissAppearancePicker()">
              Позже
            </ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding appearance-picker-content">
        <p class="appearance-picker-text">
          Можно оставить тёмную тему, включить светлую или следовать теме устройства.
          Позже выбор доступен в Настройках.
        </p>
        <ion-button
          expand="block"
          fill="solid"
          class="appearance-picker-btn"
          @click="chooseAppearance('system')"
        >
          Автоматически
        </ion-button>
        <ion-button
          expand="block"
          fill="solid"
          class="appearance-picker-btn"
          @click="chooseAppearance('dark')"
        >
          Тёмная
        </ion-button>
        <ion-button
          expand="block"
          fill="solid"
          class="appearance-picker-btn"
          @click="chooseAppearance('light')"
        >
          Светлая
        </ion-button>
        <ion-button expand="block" fill="clear" class="appearance-picker-later-btn" @click="dismissAppearancePicker()">
          Позже
        </ion-button>
      </ion-content>
    </ion-modal>

    <!-- Предложение обновить приложение (админский флаг) -->
    <ion-modal
      :is-open="showUpdatePromptModal"
      :backdrop-dismiss="true"
      class="update-prompt-modal"
      @didDismiss="onUpdatePromptModalDismissed"
    >
      <ion-header class="ion-no-border">
        <ion-toolbar>
          <ion-title>Доступно обновление</ion-title>
          <ion-buttons slot="end">
            <ion-button fill="clear" @click="dismissUpdatePrompt">Позже</ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding">
        <p class="update-prompt-text">{{ updatePromptMessage }}</p>
        <ion-button expand="block" class="update-prompt-update-btn" @click="openStoreForUpdate">
          Обновить
        </ion-button>
        <ion-button expand="block" fill="clear" class="update-prompt-later-btn" @click="dismissUpdatePrompt">
          Напомнить позже
        </ion-button>
      </ion-content>
    </ion-modal>

    <ion-modal
      :is-open="showSupportChannelModal"
      class="support-channel-modal"
      @didDismiss="showSupportChannelModal = false">
      <ion-header>
        <ion-toolbar>
          <ion-title>Техподдержка</ion-title>
          <ion-buttons slot="end">
            <ion-button fill="clear" @click="showSupportChannelModal = false">Закрыть</ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding support-channel-content">
        <p class="support-channel-hint ion-text-center">
          {{ isAuthenticated ? 'Рекомендуем написать в Liga.Chat' : 'Выберите удобный канал связи' }}
        </p>
        <div class="support-channel-grid">
          <button
            v-if="isAuthenticated"
            type="button"
            class="support-channel-btn support-channel-btn--primary"
            @click="openInternalSupportChat">
            <span class="support-channel-icon-wrap">
              <ion-icon :icon="chatbubbleEllipsesOutline" />
            </span>
            <span class="support-channel-label">Liga.Chat</span>
          </button>
          <button
            type="button"
            class="support-channel-btn"
            :class="{ 'support-channel-btn--primary': !isAuthenticated }"
            @click="openExternalSupportChannel(supportTelegramUrl)">
            <span class="support-channel-icon-wrap">
              <img :src="supportTelegramIcon" alt="" width="48" height="48" decoding="async" />
            </span>
            <span class="support-channel-label">Telegram</span>
          </button>
          <button
            type="button"
            class="support-channel-btn"
            @click="openExternalSupportChannel(supportVkUrl)">
            <span class="support-channel-icon-wrap">
              <img :src="supportVkIcon" alt="" width="48" height="48" decoding="async" />
            </span>
            <span class="support-channel-label">VK</span>
          </button>
          <button
            v-if="supportBlueskyUrl"
            type="button"
            class="support-channel-btn"
            @click="openExternalSupportChannel(supportBlueskyUrl)">
            <span class="support-channel-icon-wrap support-channel-icon-wrap--wide">
              <img :src="supportBlueskyIcon" alt="" width="48" height="48" decoding="async" />
            </span>
            <span class="support-channel-label">Bluesky</span>
          </button>
        </div>
      </ion-content>
    </ion-modal>
    <MessengerOnboardingModal :is-open="showMessengerOnboarding" @done="closeMessengerOnboarding" />
    <MessengerKeyBackupModal
      :is-open="showMessengerKeyBackupRestore"
      mode="restore"
      :backup-blob="messengerKeyBackupBlob"
      @restored="onMessengerKeyBackupRestored"
      @skipped="onMessengerKeyBackupRestoreSkipped"
      @done="closeMessengerKeyBackupRestore"
    />
  </ion-app>
</template>

<script lang="ts">
// import BottomCustomMenu from '@/BottomCustomMenu.vue';
import { LEGAL } from '@/config/legal';
import { STORE_LINKS, UPDATE_PROMPT_DISMISSED_KEY } from '@/config/store-links';
import appConfigService from '@/services/app-config.service';
import { HmsPush } from '@/services/hms-push.plugin';
import MediaUtils from "@/services/media.utils";
import MessengerService from "@/services/messenger.service";
import { ensureMessengerCryptoReady, scheduleRedistributeKnownChatKeys, hasLocalMessengerIdentity, allowMessengerIdentityCreate, setServerKeyBackupExists, invalidateChatKeyMiss } from "@/services/messenger-crypto.service";
import { hydrateMessengerOutbox } from "@/services/messenger-outbox.service";
import { clearAppIconBadge } from "@/services/app-icon-badge";
import { flushPendingPushOpen, registerAdminPushNotifications } from "@/services/push.service";
import { flushPendingDeepLink } from "@/services/deep-link.service";
import { syncMessengerPushBannerSuppress } from "@/services/messenger-push-suppress";
import {
  formatMessengerUnread,
  getMessengerUnreadTotal,
  refreshMessengerUnread,
  setMessengerUnreadTotal,
  subscribeMessengerUnread,
} from "@/services/messenger-unread";
import { subscribeMessengerRealtime, reconnectMessengerRealtime, notifyMessengerLocalEvent } from "@/services/messenger-realtime.service";
import { clearDeliveredMessengerNotifications } from "@/services/messenger-notification-clear";
import MessengerOnboardingModal from "@/views/messenger/MessengerOnboardingModal.vue";
import MessengerKeyBackupModal from "@/views/messenger/MessengerKeyBackupModal.vue";
import type { IMessengerKeyBackup } from "@/services/messenger.service";
import { SUPPORT_TELEGRAM_URL, SUPPORT_VK_URL } from "@/config/support-channels";
import { normalizeReleaseStreamUrl } from "@/utils/normalize-stream-url";
import { resolveAvatarUrl } from "@/utils/avatar-url";
import { ScreenOrientation } from "@awesome-cordova-plugins/screen-orientation";
import { App } from "@capacitor/app";
import { Browser } from "@capacitor/browser";
import { Capacitor, CapacitorHttp } from "@capacitor/core";
import { Directory, Filesystem } from "@capacitor/filesystem";
import { Network } from "@capacitor/network";
import { Preferences } from "@capacitor/preferences";
import { ensureNativeSplashSafety } from "@/services/native-splash.service";
import {
  AppearancePreference,
  getCurrentAppearancePreference,
  getCurrentEffectiveTheme,
  isAppearancePickerSeen,
  markAppearancePickerSeen,
  setAppearancePreference,
  syncNativeStatusBar,
} from "@/services/appearance.service";
import logoWhite from "@/theme/liga-logo-white.png";
import logoBlack from "@/theme/liga-logo-black.png";
import {
  Gesture,
  IonApp,
  IonAvatar,
  IonBadge,
  IonButton,
  IonButtons,
  IonContent,
  IonFab,
  IonFabButton,
  IonFooter,
  IonHeader,
  IonIcon,
  IonImg,
  IonItem,
  IonItemDivider,
  IonLabel,
  IonList,
  IonMenu,
  IonModal,
  IonNote,
  IonRouterOutlet,
  IonSpinner,
  IonSplitPane,
  IonTabBar,
  IonTabButton,
  IonTabs,
  IonTitle,
  IonToast,
  IonToolbar,
  createGesture,
  isPlatform,
  menuController,
  useBackButton,
} from "@ionic/vue";
import { AudioTrack, RmxAudioPlayer } from "capacitor-plugin-playlist";
import dayjs from "dayjs";
import {
  apps,
  calendarOutline,
  cardOutline,
  chatbubbleEllipsesOutline,
  chevronDownOutline,
  chevronBackOutline,
  chevronForwardOutline,
  chevronUpOutline,
  closeOutline,
  cloudOffline,
  cloudUploadOutline,
  contractOutline,
  documentOutline,
  discOutline,
  documentTextOutline,
  fileTrayFullOutline,
  filmOutline,
  folderOutline,
  gridOutline,
  helpOutline,
  homeOutline,
  keyOutline,
  libraryOutline,
  linkOutline,
  listOutline,
  menuOutline,
  musicalNotesOutline,
  newspaperOutline,
  paperPlaneOutline,
  pause,
  pauseOutline,
  peopleOutline,
  personOutline,
  play,
  playBack,
  playForward,
  playOutline,
  playSkipBack,
  playSkipBackOutline,
  playSkipForward,
  playSkipForwardOutline,
  readerOutline,
  reloadOutline,
  reorderTwoOutline,
  repeatOutline,
  returnDownBackOutline,
  ribbonOutline,
  pricetagOutline,
  rocketOutline,
  schoolOutline,
  settingsOutline,
  starOutline,
  statsChartOutline,
  ticketOutline,
  timeOutline,
  timerOutline,
  todayOutline,
} from "ionicons/icons";
import {
  computed,
  defineComponent,
  inject,
  onMounted,
  provide,
  reactive,
  ref,
  watch,
} from "vue";
import { MenuButton } from "./model/menubutton.model";
import { AppSectionKey } from "./model/app-section.model";
import { PlayerBar } from "./model/playerbar.model";
import { Release } from "./model/release.model";
import AccountService from "./services/account.service";
// @ts-ignore
import { MittEmitter } from "mitt-emitter";
import { CalendarType } from "./model/calendartype.model";
import { GlobalContext } from "./model/globalcontext.model";
import { GoogleMedia } from "./model/googlemedia.model";
import { PlayerModes } from "./model/player.mode";
import router from "./router";
import CalendarService from "./services/calendar.service";
import AppSectionService from "./services/app-section.service";
import FilesystemCustomUtils from "./services/filesystem.custom.utils";
import LogoService from "./services/logo.service";
import eventsService from "./services/events.service";
import store from "./store";

export default defineComponent({
  name: "App",
  setup() {
    const AVATAR_FILE_NAME = "liga-avatar.jpeg";
    const menuButton = inject("menuButton") as MenuButton;
    const accountService = inject("accountService") as AccountService;
    const calendarService = inject("calendarService") as CalendarService;
    const appSectionService = inject("appSectionService") as AppSectionService;
    const playerBarInit = inject("playerBar") as PlayerBar;
    const playerBar = reactive(playerBarInit);
    const releaseEntity = inject("release") as Release;
    const audioRef = ref();
    const emitter = inject("emitter") as MittEmitter;
    const globalContextInit = inject("globalContext") as GlobalContext;
    const mediaUtils = new MediaUtils();
    const isMobile = globalContextInit.isMobile;
    const globalContext = reactive(globalContextInit);
    provide("globalContext", globalContext);
    // На web audioPlayer не provide'ится — default гасит Vue warn; вызовы только под isMobile.
    const audioPlayer = inject("audioPlayer", null) as unknown as RmxAudioPlayer;
    const playNowModal = ref();
    const microPlayerDragger = ref();

    const filesystemCustomUtils = new FilesystemCustomUtils();

    const lostNetwork = ref(false);
    const openNetworkToast = (state: boolean) => (lostNetwork.value = state);

    const showPrivacyConsentModal = ref(false);
    const privacyConsentAccepting = ref(false);
    const showUpdatePromptModal = ref(false);
    const showAppearancePickerModal = ref(false);
    let appearancePickerDismissInFlight = false;
    const updatePromptMessage = ref('');
    const updatePromptVersion = ref(0);
    let updatePromptDismissInFlight = false;
    const showSupportChannelModal = ref(false);
    const privacyConsentCheckDone = ref(false);
    const privacyOfferUrl = LEGAL.offerUrl;
    const effectiveTheme = computed(() => globalContext.effectiveTheme || getCurrentEffectiveTheme());
    const menuHeaderLogoSrc = computed(() =>
      effectiveTheme.value === 'light' ? logoBlack : logoWhite
    );

    // Очередь блокирующих модалок: privacy → update → appearance → key-backup → messenger onboarding.
    // Privacy — fixed overlay (не ion-modal), чтобы не валить WebView на Android 15+.
    // messenger*Blocking — refs из setup, чтобы anyBlockingModalOpen / offline-гард видели Options data-модалки.
    let messengerOnboardingFlushCb: (() => void) | null = null;
    const messengerOnboardingBlocking = ref(false);
    const messengerKeyBackupBlocking = ref(false);
    /** true после волны privacy→update→appearance — можно открывать messenger ion-modal. */
    const blockingQueueSettled = ref(false);

    const setPrivacyConsentOpen = (open: boolean) => {
      showPrivacyConsentModal.value = open;
      if (!open) {
        privacyConsentAccepting.value = false;
      }
    };

    const registerMessengerOnboardingFlush = (cb: () => void) => {
      messengerOnboardingFlushCb = cb;
    };

    const requestMessengerOnboardingFlush = () => {
      messengerOnboardingFlushCb?.();
    };

    const markBlockingQueueSettled = () => {
      blockingQueueSettled.value = true;
    };

    const anyBlockingModalOpen = () =>
      showPrivacyConsentModal.value ||
      showUpdatePromptModal.value ||
      showAppearancePickerModal.value ||
      messengerOnboardingBlocking.value ||
      messengerKeyBackupBlocking.value;

    // Offline-таймер в AccountService смотрит blockingConsentOpen — держим в sync со всей очередью.
    watch(
      [
        showPrivacyConsentModal,
        showUpdatePromptModal,
        showAppearancePickerModal,
        messengerOnboardingBlocking,
        messengerKeyBackupBlocking,
      ],
      () => {
        globalContext.blockingConsentOpen = anyBlockingModalOpen();
      },
      { immediate: true }
    );

    const mimeExtensions: Map<string, string> = new Map([
      ["image/jpeg", "jpg"],
      ["image/png", "png"],
      ["application/json", "json"],
      ["audio/mpeg", "mp3"],
      ["video/mp4", "mp4"],
      ["video/mpeg", "mpeg"],
      ["video/quicktime", "mov"],
      ["application/pdf", "pdf"],
    ]);

    const calendarsDic = [
      new CalendarType("liga-team", "liga.Team", "#33b679"),
    ];

    onMounted(async () => {
      void appSectionService.loadSections();
      const menuButtonRight = await Preferences.get({ key: "menuButtonRight" });
      menuButton.position = menuButtonRight.value || "left";
      Preferences.get({ key: "musicBeta" }).then((value) => {
        globalContext.musicBeta = "1" === value.value;
      });
      Preferences.get({ key: "videoBeta" }).then((value) => {
        globalContext.videoBeta = "1" === value.value;
      });
      Preferences.get({ key: "syncVideoGuide" }).then((value) => {
        globalContext.syncVideoGuide = "1" === value.value;
      });

      // Splash держим до settle на Login (auth restore); страховка на случай обхода Login.
      ensureNativeSplashSafety(4000);

      // Показать окно согласия с политикой конфиденциальности при первом входе (если пользователь авторизован)
      const checkPrivacyConsent = async () => {
        if (privacyConsentCheckDone.value || !accountService.authenticated) return;
        privacyConsentCheckDone.value = true;
        const res = await Preferences.get({ key: LEGAL.privacyConsentKey });
        if (res.value !== "true") {
          setPrivacyConsentOpen(true);
        } else if (!anyBlockingModalOpen()) {
          requestMessengerOnboardingFlush();
        }
      };
      setTimeout(checkPrivacyConsent, 1500);
      setTimeout(() => {
        void checkUpdatePrompt().then(() => {
          if (!anyBlockingModalOpen()) {
            requestMessengerOnboardingFlush();
          }
        });
      }, 2200);
      setTimeout(() => {
        void checkAppearancePicker().then(() => {
          if (showUpdatePromptModal.value || showAppearancePickerModal.value) {
            return;
          }
          markBlockingQueueSettled();
          if (!anyBlockingModalOpen()) {
            requestMessengerOnboardingFlush();
          }
        });
      }, 2800);
    });

    const checkUpdatePrompt = async () => {
      // Только нативные сборки — для web баннер сторов не актуален
      if (!Capacitor.isNativePlatform()) return;
      if (anyBlockingModalOpen()) return;
      try {
        const cfg = await appConfigService.getPublicConfig();
        if (!cfg?.updatePromptEnabled || !cfg.updatePromptVersion) return;
        const dismissed = await Preferences.get({ key: UPDATE_PROMPT_DISMISSED_KEY });
        const dismissedVersion = Number(dismissed.value || 0) || 0;
        if (dismissedVersion >= cfg.updatePromptVersion) return;
        updatePromptMessage.value = cfg.updatePromptMessage;
        updatePromptVersion.value = cfg.updatePromptVersion;
        showUpdatePromptModal.value = true;
      } catch (e) {
        console.warn('checkUpdatePrompt failed', e);
      }
    };

    const checkAppearancePicker = async () => {
      if (anyBlockingModalOpen()) return;
      try {
        if (await isAppearancePickerSeen()) return;
        showAppearancePickerModal.value = true;
      } catch (e) {
        console.warn('checkAppearancePicker failed', e);
      }
    };

    const continueAfterUpdatePrompt = () => {
      setTimeout(() => {
        void checkAppearancePicker().then(() => {
          if (showAppearancePickerModal.value) {
            return;
          }
          markBlockingQueueSettled();
          requestMessengerOnboardingFlush();
        });
      }, 400);
    };

    const syncAppearanceToContext = () => {
      globalContext.appearance = getCurrentAppearancePreference();
      globalContext.effectiveTheme = getCurrentEffectiveTheme();
    };

    const dismissAppearancePicker = async () => {
      appearancePickerDismissInFlight = true;
      await markAppearancePickerSeen();
      showAppearancePickerModal.value = false;
      appearancePickerDismissInFlight = false;
      markBlockingQueueSettled();
      requestMessengerOnboardingFlush();
    };

    const onAppearancePickerDismissed = () => {
      showAppearancePickerModal.value = false;
      if (!appearancePickerDismissInFlight) {
        void markAppearancePickerSeen();
      }
      markBlockingQueueSettled();
      requestMessengerOnboardingFlush();
    };

    const chooseAppearance = async (mode: AppearancePreference) => {
      appearancePickerDismissInFlight = true;
      await setAppearancePreference(mode);
      await markAppearancePickerSeen();
      syncAppearanceToContext();
      showAppearancePickerModal.value = false;
      appearancePickerDismissInFlight = false;
      markBlockingQueueSettled();
      requestMessengerOnboardingFlush();
    };

    const dismissUpdatePrompt = async () => {
      updatePromptDismissInFlight = true;
      if (updatePromptVersion.value > 0) {
        await Preferences.set({
          key: UPDATE_PROMPT_DISMISSED_KEY,
          value: String(updatePromptVersion.value),
        });
      }
      showUpdatePromptModal.value = false;
      updatePromptDismissInFlight = false;
      continueAfterUpdatePrompt();
    };

    const onUpdatePromptModalDismissed = () => {
      showUpdatePromptModal.value = false;
      if (!updatePromptDismissInFlight && updatePromptVersion.value > 0) {
        void Preferences.set({
          key: UPDATE_PROMPT_DISMISSED_KEY,
          value: String(updatePromptVersion.value),
        });
      }
      continueAfterUpdatePrompt();
    };

    const resolveStoreUpdateUrl = async (): Promise<string> => {
      if (isPlatform('ios')) return STORE_LINKS.apple;
      if (isPlatform('android')) {
        try {
          const { provider } = await HmsPush.getPushProvider();
          if (provider === 'HMS') return STORE_LINKS.huawei;
        } catch {
          /* FCM / без плагина — Play */
        }
        return STORE_LINKS.google;
      }
      return STORE_LINKS.apple;
    };

    const openStoreForUpdate = async () => {
      const url = await resolveStoreUpdateUrl();
      await dismissUpdatePrompt();
      await Browser.open({ url }).catch((err) => console.log(err));
    };

    // Показать окно согласия после входа (при переходе на главную страницу)
    const skipRoutesConsent = ["Login", "SignUp", "ResetPassword", "BadConnection"];
    router.afterEach(async (to) => {
      if (!to.name || skipRoutesConsent.includes(to.name as string) || !accountService.authenticated || privacyConsentCheckDone.value) return;
      privacyConsentCheckDone.value = true;
      const res = await Preferences.get({ key: LEGAL.privacyConsentKey });
      if (res.value !== "true") {
        setPrivacyConsentOpen(true);
      } else if (!anyBlockingModalOpen()) {
        requestMessengerOnboardingFlush();
      }
    });

    const openPrivacyPolicy = () => {
      setPrivacyConsentOpen(false);
      router.push("/privacy-policy");
    };

    const acceptPrivacyConsent = async () => {
      if (privacyConsentAccepting.value) return;
      privacyConsentAccepting.value = true;
      try {
        await Preferences.set({ key: LEGAL.privacyConsentKey, value: "true" });
      } catch (e) {
        console.warn('acceptPrivacyConsent Preferences.set failed', e);
      }
      setPrivacyConsentOpen(false);
      // Единая пауза перед следующими модалками (ion-modal update/appearance).
      await new Promise<void>((resolve) => setTimeout(resolve, 800));
      await checkUpdatePrompt();
      if (!showUpdatePromptModal.value) {
        await checkAppearancePicker();
      }
      if (!showUpdatePromptModal.value && !showAppearancePickerModal.value) {
        markBlockingQueueSettled();
        requestMessengerOnboardingFlush();
      }
    };

    useBackButton(10, () => {
      router.replace("/showcase");
    });

    if (isMobile && audioPlayer) {
      audioPlayer.on("status", (statusCallback) => {
        if (undefined === statusCallback || undefined === statusCallback.value)
          return;

        console.log('statusCallback', statusCallback);

        if ("duration" in statusCallback.value) {
          if (statusCallback.value.duration > 0) {
            playerBar.currentTrackTotalTime = mediaUtils.formatTime(
              statusCallback.value.duration
            );
            playerBar.currentDuration = Math.floor(statusCallback.value.duration);
          }
        }
        if ("currentPosition" in statusCallback.value) {
          playerBar.currentPosition = statusCallback.value.currentPosition;
          playerBar.currentTrackCurrentTime = mediaUtils.formatTime(
            statusCallback.value.currentPosition
          );
          playerBar.playingProgress =
            100 - (playerBar.currentPosition / playerBar.currentDuration) * 100;
        }
        if (
          "currentIndex" in statusCallback.value &&
          audioPlayer.isPlaying
        ) {
          if (
            statusCallback.value.currentIndex !== playerBar.currentTrackIdx
          ) {
            playerBar.currentTrackIdx = statusCallback.value.currentIndex;
          }
        }
        if ("status" in statusCallback.value) {
          playerBar.isReady = "loading" !== statusCallback.value.status;

          if (statusCallback.value.status === "playing") {
            playerBar.currentTrackTotalTime = mediaUtils.formatTime(
              playerBar.musicList[playerBar.currentTrackIdx].duration
            );
            playerBar.playing = true;
            playerBar.paused = false;
            playerBar.visible = !playerBar.microMode && router.currentRoute.value.path !== "/video";
          } else if (statusCallback.value.status === "paused") {
            playerBar.playing = false;
            playerBar.paused = true;
          } else if (statusCallback.value.status === "error") {
            // this.emitter.emit("music-player-loaded-list", true);
          }
        }
      });
    }

    return {
      todayOutline,
      homeOutline,
      ribbonOutline,
      pricetagOutline,
      returnDownBackOutline,
      chevronBackOutline,
      readerOutline,
      schoolOutline,
      documentTextOutline,
      discOutline,
      listOutline,
      personOutline,
      chevronForwardOutline,
      menuOutline,
      settingsOutline,
      peopleOutline,
      keyOutline,
      libraryOutline,
      cloudUploadOutline,
      playOutline,
      pauseOutline,
      play,
      pause,
      chevronDownOutline,
      chevronUpOutline,
      contractOutline,
      closeOutline,
      playSkipBackOutline,
      playSkipForwardOutline,
      playSkipBack,
      playSkipForward,
      playForward,
      timeOutline,
      timerOutline,
      musicalNotesOutline,
      filmOutline,
      folderOutline,
      documentOutline,
      reloadOutline,
      menuButton,
      accountService,
      appSectionService,
      playerBar,
      releaseEntity,
      audioRef,
      emitter,
      mimeExtensions,
      globalContext,
      mediaUtils,
      isMobile,
      helpOutline,
      audioPlayer,
      apps,
      repeatOutline,
      calendarService,
      lostNetwork,
      openNetworkToast,
      AVATAR_FILE_NAME,
      rocketOutline,
      fileTrayFullOutline,
      paperPlaneOutline,
      calendarsDic,
      starOutline,
      newspaperOutline,
      gridOutline,
      statsChartOutline,
      playNowModal,
      filesystemCustomUtils,
      reorderTwoOutline,
      microPlayerDragger,
      cloudOffline,
      calendarOutline,
      linkOutline,
      ticketOutline,
      cardOutline,
      chatbubbleEllipsesOutline,
      playBack,
      showPrivacyConsentModal,
      privacyConsentAccepting,
      showUpdatePromptModal,
      showAppearancePickerModal,
      updatePromptMessage,
      showSupportChannelModal,
      privacyOfferUrl,
      LEGAL,
      openPrivacyPolicy,
      acceptPrivacyConsent,
      dismissUpdatePrompt,
      onUpdatePromptModalDismissed,
      openStoreForUpdate,
      effectiveTheme,
      menuHeaderLogoSrc,
      dismissAppearancePicker,
      onAppearancePickerDismissed,
      chooseAppearance,
      privacyConsentCheckDone,
      anyBlockingModalOpen,
      registerMessengerOnboardingFlush,
      messengerOnboardingBlocking,
      messengerKeyBackupBlocking,
      blockingQueueSettled,
      // BottomCustomMenu
    };
  },
  components: {
    IonApp,
    IonRouterOutlet,
    IonTabs,
    IonTabBar,
    IonTabButton,
    IonIcon,
    IonFab,
    IonFabButton,
    IonMenu,
    IonFooter,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonList,
    IonItem,
    IonItemDivider,
    IonLabel,
    IonNote,
    IonButton,
    IonButtons,
    IonToast,
    IonAvatar,
    IonBadge,
    IonImg,
    IonModal,
    IonSpinner,
    IonSplitPane,
    MessengerOnboardingModal,
    MessengerKeyBackupModal,
  },
  data() {
    return {
      appVersion: "-",
      hasAnyAuthorityValue: false,
      showPlayList: false,
      isDragPlayerRange: false,
      showExtendedPlayer: false,
      showPlayerDelay: false,
      trackPath: "",
      isLandscapeMode: false,
      countClassesNeedReplace: 0,
      countClassesNeedAccept: 0,
      avatarUrl: "",
      userLastname: store.getters.account ? store.getters.account.lastName : "",
      userFirstname: store.getters.account
        ? store.getters.account.firstName
        : "",
      playerAlbumImage: "",
      logoService: new LogoService(),

      supportTelegramIcon: require("@/assets/support/telegram.svg"),
      supportVkIcon: require("@/assets/support/vk.svg"),
      supportBlueskyIcon: require("@/assets/support/bluesky.svg"),
      supportTelegramUrl: SUPPORT_TELEGRAM_URL,
      supportVkUrl: SUPPORT_VK_URL,
      /** Ссылка на чат/профиль Bluesky; пусто — кнопка скрыта */
      supportBlueskyUrl: "",
      messengerService: new MessengerService(),
      showMessengerOnboarding: false,
      messengerOnboardingDeferred: false,
      showMessengerKeyBackupRestore: false,
      messengerKeyBackupDeferred: false,
      messengerKeyBackupBlob: null as IMessengerKeyBackup | null,
      messengerUnreadCount: getMessengerUnreadTotal(),
      unsubscribeMessengerUnread: null as null | (() => void),
      unsubscribeMessengerRealtime: null as null | (() => void),

      todayEventsCount: 0,
      todayNewsCount: 0,
      todaySectorFailsCount: 0,

      returnsPendingCount: 0,
      desktopLayout: false,
      desktopMenuCollapsed: false,

      isPushEnabled: true,

      showPlayNow: false,

      downloadProcessRunning: false,
      downloadProcess: 0,
      microPlayerPosition: 0,
      pressTime: 0,
      updatedCurrentTime: 0,
    };
  },

  computed: {
    isAuthenticated: () => {
      return store.getters.authenticated;
    },
    menuUserDisplayName(): string {
      return `${this.userFirstname || ""} ${this.userLastname || ""}`.trim();
    },
    isLogin() {
      return this.$router.currentRoute.value.name === "Login";
    },
    isShowcase() {
      return this.$router.currentRoute.value.name === "Showcase";
    },
    /** FAB меню: скрыть на витрине; на десктопе скрыть только если split-pane активен (ширина lg+). */
    showMainMenuFab(): boolean {
      if (!this.isViewWithMenu() || this.isPageWithOwnHeader || this.isPrivacyPolicy || this.isAccountDeletion || this.isOfferSupplement) {
        return false;
      }
      if (this.isShowcase) {
        return false;
      }
      if (this.useDesktopLayout) {
        return false;
      }
      return true;
    },
    isSignUp() {
      return this.$router.currentRoute.value.name === "SignUp";
    },
    isResetPassword() {
      return this.$router.currentRoute.value.name === "ResetPassword";
    },
    isChangePassword() {
      return this.$router.currentRoute.value.name === "ChangePassword";
    },
    isWorkoutList() {
      return this.$router.currentRoute.value.name === "WorkoutList";
    },
    useDesktopLayout(): boolean {
      return !this.isMobile && this.desktopLayout;
    },
    /** split-pane: на десктопе сайдбар, если меню не свёрнуто; иначе false (контент на всю ширину). */
    splitPaneWhen(): string | boolean {
      if (this.useDesktopLayout && this.desktopMenuCollapsed) {
        return false;
      }
      return 'lg';
    },
    /** Нижние вкладки: мобильная вёрстка и нативное приложение; на десктопе (≥992px) — боковое меню. */
    showBottomNav(): boolean {
      return this.isAuthenticated && !this.useDesktopLayout;
    },
    isTodayWorkouts() {
      return this.$router.currentRoute.value.name === "TodayWorkouts";
    },
    isTodayEvents() {
      return this.$router.currentRoute.value.name === "TodayEvents";
    },
    isTodayNews() {
      return this.$router.currentRoute.value.name === "TodayNews";
    },
    isTodaySector() {
      return this.$router.currentRoute.value.name === "TodaySector";
    },
    isInstructorReplace() {
      return this.$router.currentRoute.value.name === "InstructorReplace";
    },
    isReplacementCandidate() {
      return this.$router.currentRoute.value.name === "ReplacementCandidate";
    },
    isSummary() {
      return this.$router.currentRoute.value.name === "Summary";
    },
    isPrograms() {
      const n = this.$router.currentRoute.value.name;
      return n === "Programs" || n === "ProgramReleases";
    },
    isPlaylistList() {
      return this.$router.currentRoute.value.name === "PlaylistList";
    },
    isMusicLibrary() {
      const n = this.$router.currentRoute.value.name;
      return n === "MusicLibrary" || n === "MusicLibraryFolder";
    },
    isAdminLibraryMusic() {
      return this.$router.currentRoute.value.name === "AdminLibraryMusic";
    },
    isAdminMediaStats() {
      return this.$router.currentRoute.value.name === "AdminMediaStats";
    },
    isSkills() {
      return this.$router.currentRoute.value.name === "Skills";
    },
    isExercises() {
      return this.$router.currentRoute.value.name === "Exercises";
    },
    isWorkouts() {
      return this.$router.currentRoute.value.name === "Workouts";
    },
    isEducation() {
      return this.$router.currentRoute.value.name === "Education";
    },
    isTesting() {
      return this.$router.currentRoute.value.name === "Testing";
    },
    isEvents() {
      const name = this.$router.currentRoute.value.name;
      return name === "EventsList" || name === "EventDetail";
    },
    isMySubscriptions() {
      return this.$router.currentRoute.value.name === "MySubscriptions";
    },
    isSubscriptionDetail() {
      return this.$router.currentRoute.value.name === "SubscriptionDetail";
    },
    isMyTickets() {
      return this.$router.currentRoute.value.name === "MyTickets";
    },
    isMessenger() {
      const name = this.$router.currentRoute.value.name as string;
      return !!name && name.startsWith("Messenger");
    },
    isMessengerInbox() {
      return this.$router.currentRoute.value.name === "MessengerInbox";
    },
    isUsefulLinks() {
      return this.$router.currentRoute.value.name === "UsefulLinks";
    },
    isAdminUsefulLinks() {
      return this.$router.currentRoute.value.name === "AdminUsefulLinks";
    },
    isEventPaymentSuccess() {
      return this.$router.currentRoute.value.name === "EventPaymentSuccess";
    },
    isReleasePage() {
      return this.$router.currentRoute.value.name === "ReleasePage";
    },
    isRelease() {
      return this.$router.currentRoute.value.name === "ReleaseMain";
    },
    isReleaseMusic() {
      return this.$router.currentRoute.value.path === "/music";
    },
    isReleaseVideo() {
      return this.$router.currentRoute.value.path === "/video";
    },
    isReleaseGuide() {
      return this.$router.currentRoute.value.path === "/guide";
    },
    isAccount() {
      return this.$router.currentRoute.value.name === "Account";
    },
    isCertification() {
      return this.$router.currentRoute.value.name === "Certification";
    },
    isMonthSheet() {
      return this.$router.currentRoute.value.name === "MonthSheet";
    },
    isMemories() {
      return this.$router.currentRoute.value.name === "Memories";
    },
    isCharts() {
      return this.$router.currentRoute.value.name === "Charts";
    },
    isUsers() {
      return this.$router.currentRoute.value.name === "Users";
    },
    isAdminRoles() {
      return this.$router.currentRoute.value.name === "AdminRoles";
    },
    isAdminAppSections() {
      return this.$router.currentRoute.value.name === "AdminAppSections";
    },
    isAdminEducationSections() {
      return this.$router.currentRoute.value.name === "AdminEducationSections";
    },
    isAdminMediaUpload() {
      return this.$router.currentRoute.value.name === "AdminMediaUpload";
    },
    isAdminReleases() {
      const n = this.$router.currentRoute.value.name;
      return n === "AdminReleases" || n === "AdminReleaseContent";
    },
    isAdminConversionQueue() {
      return this.$router.currentRoute.value.name === "AdminConversionQueue";
    },
    isAdminPayments() {
      return this.$router.currentRoute.value.name === "AdminPayments";
    },
    isAdminReturns() {
      return this.$router.currentRoute.value.name === "AdminReturns";
    },
    isAdminSubscriptions() {
      const name = this.$router.currentRoute.value.name;
      return name === "AdminSubscriptionsList" || name === "AdminSubscriptionNew" || name === "AdminSubscriptionEdit";
    },
    isAdminSubscriptionPurchases() {
      return this.$router.currentRoute.value.name === "AdminSubscriptionPurchases";
    },
    isAdminPromoCodes() {
      const name = this.$router.currentRoute.value.name;
      return name === "AdminPromoCodesList" || name === "AdminPromoCodeNew" || name === "AdminPromoCodeEdit";
    },
    isAdminVideoUpload() {
      return this.$router.currentRoute.value.name === "AdminVideoUpload";
    },
    isAdminTesting() {
      return this.$router.currentRoute.value.name === "AdminTesting";
    },
    isAdminEvents() {
      const name = this.$router.currentRoute.value.name;
      return name === "AdminEventsList" || name === "AdminEventNew" || name === "AdminEventEdit" || name === "AdminEventRegistrations";
    },
    isPageWithOwnHeader() {
      return this.isSkills || this.isExercises || this.isWorkouts || this.isEducation || this.isTesting || this.isEvents || this.isEventPaymentSuccess || this.isMyTickets || this.isMySubscriptions || this.isSubscriptionDetail || this.isUsefulLinks || this.isMessenger || this.isUsers || this.isAdminRoles || this.isAdminAppSections || this.isAdminMediaUpload || this.isAdminReleases || this.isAdminConversionQueue || this.isAdminLibraryMusic || this.isAdminMediaStats || this.isAdminPayments || this.isAdminReturns || this.isAdminSubscriptions || this.isAdminSubscriptionPurchases || this.isAdminPromoCodes || this.isAdminVideoUpload || this.isAdminEducationSections || this.isAdminTesting || this.isAdminEvents || this.isAdminUsefulLinks || this.isSettings || this.isPrograms || this.isPlaylistList || this.isMusicLibrary || this.isShowcase;
    },
    isPrivacyPolicy() {
      return this.$router.currentRoute.value.name === 'PrivacyPolicy';
    },
    isAccountDeletion() {
      return this.$router.currentRoute.value.name === 'AccountDeletion';
    },
    isOfferSupplement() {
      return this.$router.currentRoute.value.name === 'OfferSupplement';
    },
    isFeedback() {
      return this.$router.currentRoute.value.name === "Feedback";
    },
    isProgramFeedback() {
      return this.$router.currentRoute.value.name === "ProgramFeedback";
    },
    isProgramFeedbackResults() {
      return this.$router.currentRoute.value.name === "ProgramFeedbackResults";
    },
    isSettings() {
      return this.$router.currentRoute.value.name === "Settings";
    },
    isBadConnection() {
      return this.$router.currentRoute.value.name === "BadConnection";
    },
    isMicroMode(): boolean {
      return this.playerBar ? this.playerBar.microMode : false;
    },
    isPlaylistMode(): boolean {
      return this.playerBar
        ? this.playerBar.visible &&
        this.playerBar.currentMode === PlayerModes.PLAYLIST
        : false;
    },
    isPlayListView() {
      return this.$router.currentRoute.value.name === "PlayListView";
    },
    updatedCurrentTimeStr(): string {
      return this.mediaUtils.formatTime(this.updatedCurrentTime);
    },
    playingProgress(): number {
      return this.playerBar.playingProgress;
    },
    messengerUnreadLabel(): string {
      return formatMessengerUnread(this.messengerUnreadCount);
    },
  },

  watch: {
    '$store.state.account.authenticated'(authenticated: boolean) {
      if (authenticated) {
        void this.loadReturnsPendingCount();
        void this.checkMessengerOnboarding();
        void this.startMessengerUnreadTracking();
      } else {
        this.returnsPendingCount = 0;
        this.showMessengerOnboarding = false;
        this.messengerOnboardingDeferred = false;
        this.showMessengerKeyBackupRestore = false;
        this.messengerKeyBackupDeferred = false;
        this.messengerKeyBackupBlob = null;
        if (this.messengerOnboardingBlocking !== undefined) {
          this.messengerOnboardingBlocking = false;
        }
        if (this.messengerKeyBackupBlocking !== undefined) {
          this.messengerKeyBackupBlocking = false;
        }
        this.stopMessengerUnreadTracking();
        setMessengerUnreadTotal(0);
      }
    },
    '$store.state.account.userIdentity'() {
      void this.loadReturnsPendingCount();
    },
    '$route.path'() {
      void this.loadReturnsPendingCount();
      void this.syncMessengerPushSuppress();
    },
    isMessenger(value: boolean) {
      void syncMessengerPushBannerSuppress(!!value);
    },
  },

  beforeMount() {
    this.updateDesktopLayout();
    this.restoreDesktopMenuCollapsed();
    try {
      this.downloadProgramsLogo();
    } catch (ex) {
      console.error(ex);
    }
  },

  mounted() {
    // force init
    this.globalContext.showMenuNotification;
    this.globalContext.isManager;
    this.globalContext.offlineMode;

    void this.refreshHasOfflineLibraryMusic();
    this.unsubscribeMessengerUnread = subscribeMessengerUnread(count => {
      this.messengerUnreadCount = count;
    });
    void this.syncMessengerPushSuppress();
    this.registerMessengerOnboardingFlush?.(() => {
      void this.flushDeferredMessengerQueue();
    });
    if (this.isAuthenticated) {
      void this.checkMessengerOnboarding();
      void this.startMessengerUnreadTracking();
    }
    this.emitter.on('library-music-offline-changed', () => {
      void this.refreshHasOfflineLibraryMusic();
    });

    App.getInfo()
      .then((appInfo) => {
        this.appVersion = appInfo.version;
      })
      .catch(() => {
        //not implemented
        this.appVersion = `${dayjs().year()}.${dayjs().month()}`;
      });

    Filesystem.readdir({
      path: "",
      directory: Directory.Data,
    }).then((response) => {
      const avatarFile = response.files.find((f) => {
        return f.name == this.AVATAR_FILE_NAME;
      });
      if (undefined !== avatarFile) {
        Filesystem.getUri({
          path: this.AVATAR_FILE_NAME,
          directory: Directory.Data,
        }).then((res) => {
          if (res.uri !== "")
            this.avatarUrl = Capacitor.convertFileSrc(res.uri);
        });
      } else {
        const serverAvatar = resolveAvatarUrl(store.getters.account?.imageUrl);
        if (serverAvatar) this.avatarUrl = serverAvatar;
      }
    }).catch(() => {
      const serverAvatar = resolveAvatarUrl(store.getters.account?.imageUrl);
      if (serverAvatar) this.avatarUrl = serverAvatar;
    });

    try {
      if (this.isMobile) {
          this.isLandscapeMode =
            ScreenOrientation.type ==
            ScreenOrientation.ORIENTATIONS.LANDSCAPE ||
            ScreenOrientation.type ==
            ScreenOrientation.ORIENTATIONS.LANDSCAPE_PRIMARY ||
            ScreenOrientation.type ==
            ScreenOrientation.ORIENTATIONS.LANDSCAPE_SECONDARY;
        ScreenOrientation.onChange().subscribe(() => {
          this.isLandscapeMode =
            ScreenOrientation.type ==
            ScreenOrientation.ORIENTATIONS.LANDSCAPE ||
            ScreenOrientation.type ==
            ScreenOrientation.ORIENTATIONS.LANDSCAPE_PRIMARY ||
            ScreenOrientation.type ==
            ScreenOrientation.ORIENTATIONS.LANDSCAPE_SECONDARY;
        });
      }
    } catch (ex) {
      //not supported
    }

    this.$nextTick(() => {
      // this.initTabBarCounters();

      this.updateDesktopLayout();
      window.addEventListener('resize', this.updateDesktopLayout);
      void menuController.enable(true, 'mainMenu');
      void this.loadReturnsPendingCount();

      Network.addListener("networkStatusChange", (networkStatus) => {
        if (!networkStatus.connected) {
          this.openNetworkToast(true);
          this.globalContext.offlineMode = true;
          void this.refreshHasOfflineLibraryMusic();
        } else {
          this.globalContext.offlineMode = false;
        }
      });
      App.addListener("appStateChange", ({ isActive }) => {
        if (isActive) {
          // После app switcher / resume insets часто обновляются только после re-apply overlay.
          void syncNativeStatusBar();
          if (this.isMobile) {
            void clearAppIconBadge();
          }
          void this.loadReturnsPendingCount();
          if (this.isAuthenticated && this.isMobile) {
            void registerAdminPushNotifications().then(() => flushPendingPushOpen());
            void flushPendingDeepLink();
          } else if (this.isMobile) {
            // Invite без логина тоже может ждать resume после сна.
            void flushPendingDeepLink();
          }
          if (this.isAuthenticated && this.canShowSection("MESSENGER")) {
            reconnectMessengerRealtime();
            notifyMessengerLocalEvent({ type: "APP_RESUME" });
            void this.startMessengerUnreadTracking();
          }
          Network.getStatus().then((status) => {
            if (!status.connected) {
              this.openNetworkToast(true);
            }
          });

          if (this.isMobile && this.playerBar.playing) {
            this.playerBar.visible = true;
            if (this.playerBar.currentMode == PlayerModes.PLAYLIST) {
              this.openPlayList();
            } else if (this.playerBar.currentMode == PlayerModes.EXTENDED) {
              this.showExtendedPlayer = true;
            } else if (this.playerBar.currentMode == PlayerModes.MICRO) {
              this.toMicroMode();
            }
          }
        }
      });

      if (!this.isMobile) {
        this.audioRef.addEventListener("timeupdate", () => {
          if (!this.isDragPlayerRange) {
            this.playerBar.currentTrackCurrentTime = this.mediaUtils.formatTime(
              this.audioRef.currentTime
            );
            this.playerBar.currentPosition = this.audioRef.currentTime;
            this.playerBar.playingProgress =
              100 -
              (this.playerBar.currentPosition / this.playerBar.currentDuration) * 100;
          }
        });

        this.audioRef.addEventListener("ended", () => {
          ++this.playerBar.currentTrackIdx;
          if (
            this.playerBar.currentTrackIdx >
            this.playerBar.musicList.length - 1
          ) {
            this.playerBar.currentTrackIdx = 0;
          }
          this.selectTrackAndPlay(this.playerBar.currentTrackIdx);
        });

        this.audioRef.addEventListener("loadedmetadata", () => {
          this.playerBar.isReady = true;
          if (this.audioRef.duration) {
            this.playerBar.currentTrackTotalTime = this.mediaUtils.formatTime(
              this.audioRef.duration
            );
            this.playerBar.currentDuration = Math.floor(this.audioRef.duration);
          }
          if (this.audioRef.currentTime > 0) {
            this.playerBar.currentTrackCurrentTime = this.mediaUtils.formatTime(
              this.audioRef.currentTime
            );
          }
          if (this.playerBar.playing) {
            this.audioRef.play();
          }
        });

        this.audioRef.addEventListener("error", () => {
          console.log(
            "audio error: " +
            this.audioRef.error.code +
            " " +
            this.audioRef.error.message
          );
        });

        this.audioRef.addEventListener("playing", () => {
          this.playerBar.playing = true;
        });

        this.audioRef.addEventListener("paused", () => {
          this.playerBar.playing = false;
        });
      }
    });

    this.emitter.on("music-player-loaded-list", async (autoPlay?: boolean) => {
      this.playerBar.visible = true;
      const shouldPlay = autoPlay !== false;
      if (this.isMobile) {
        this.playerBar.isReady = false;
        this.addMobileTracks(this.playerBar.musicList).then((tracks) => {
          this.audioPlayer.setPlaylistItems(tracks, {
            playFromPosition: 0,
            playFromId: this.playerBar.musicList[this.playerBar.currentTrackIdx].id,
              startPaused: true
            }).then(() => {
              if (shouldPlay) {
                this.selectTrackAndPlay(this.playerBar.currentTrackIdx);
              } else {
                this.selectTrack(this.playerBar.currentTrackIdx);
                const pos = this.playerBar.currentPosition;
                if (pos > 0) {
                  this.audioPlayer.seekTo(pos);
                }
              }
          });
        });
      } else {
        if (shouldPlay) {
          this.selectTrackAndPlay(this.playerBar.currentTrackIdx);
        } else {
          this.selectTrack(this.playerBar.currentTrackIdx);
        }
      }
    });

    this.emitter.on("init-download-process", () => {
      this.downloadProcessRunning = true;
      this.downloadProcess = 0;
    });

    this.emitter.on("abort-download-process", () => {
      this.downloadProcessRunning = false;
      this.downloadProcess = 0;
    });

    this.emitter.on("music-player-restart", () => {
      this.selectTrack();
    });

    this.emitter.on("music-player-restart-and-play", () => {
      this.selectTrackAndPlay();
    });

    this.emitter.on("music-player-open-playlist", () => {
      this.showPlayList = true;
      this.playerBar.currentMode = PlayerModes.PLAYLIST;
      this.getAlbumImage();
    });

    this.emitter.on("music-player-open-extended", () => {
      this.playerBar.currentMode = PlayerModes.EXTENDED;
      this.showExtendedPlayer = true;
    });

    this.emitter.on("music-player-play", () => {
      if (this.isMobile) {
        this.audioPlayer.seekTo(this.playerBar.currentPosition).then(() => {
          this.audioPlayer.play();
        });
      } else {
        this.audioRef.play();
      }
      this.playerBar.playing = true;
      this.playerBar.paused = false;
    });

    this.emitter.on("music-player-pause", () => {
      if (this.isMobile) {
        if (this.audioPlayer) this.audioPlayer.pause();
      } else {
        if (this.audioRef) this.audioRef.pause();
      }
      this.playerBar.playing = false;
      this.playerBar.paused = true;
    });

    this.emitter.on("music-player-stop", () => {
      if (this.isMobile) {
        this.audioPlayer.pause();
      } else {
        if (this.audioRef) this.audioRef.pause();
      }
      this.playerBar.playing = false;
      this.playerBar.paused = true;
    });

    this.emitter.on("update-menu-notification", () => {
      this.globalContext.showMenuNotification;
    });

    this.emitter.on("open-menu", () => {
      void this.loadReturnsPendingCount();
      this.openMenu();
    });

    this.emitter.on("returns-pending-changed", () => {
      void this.loadReturnsPendingCount();
    });

    if (this.microPlayerDragger && this.microPlayerDragger) {
      let pressInterval: ReturnType<typeof setInterval>;
      let lastY = 0;
      const DOUBLE_CLICK_THRESHOLD = 500;
      let lastOnStart = 0;

      const microDraggerGesture: Gesture = createGesture({
        el: this.microPlayerDragger,
        threshold: 0,
        gestureName: "drag-micro-player-gesture",
        gesturePriority: 32,
        onStart: (ev) => {
          const now = Date.now();

          if (Math.abs(now - lastOnStart) <= DOUBLE_CLICK_THRESHOLD) {
            this.toExtendedPlayer();
          } else {
            lastOnStart = now;
            this.playerControls(!this.playerBar.playing);
          }

          this.pressTime = 0;
          lastY = ev.currentY;
          this.updatedCurrentTime = this.playerBar.currentPosition;
          pressInterval = setInterval(() => {
            this.pressTime += 1;
          }, 1000);
        },
        onMove: (ev) => {
          if (
            [0, 1].includes(this.microPlayerPosition) &&
            ev.deltaX < 0 &&
            Math.abs(ev.deltaX) < 100 &&
            this.pressTime < 1
          ) {
            this.microPlayerDragger.style.transform = `translateX(${ev.deltaX / 10
              }px)`;
          } else if (
            [1, 2].includes(this.microPlayerPosition) &&
            ev.deltaX > 0 &&
            Math.abs(ev.deltaX) < 100 &&
            this.pressTime < 1
          ) {
            this.microPlayerDragger.style.transform = `translateX(${ev.deltaX / 10
              }px)`;
          } else if (this.pressTime > 1 && ev.deltaY != 0) {
            const delta = lastY - ev.currentY;
            lastY = ev.currentY;
            const timeShift =
              this.playerBar.currentPosition +
              Math.abs(delta) * (delta > 0 ? 1 : -1);
            if (timeShift > 0 && timeShift < this.playerBar.currentDuration) {
              this.updatedCurrentTime = timeShift;
              this.setCurrentPosition(this.updatedCurrentTime);
            }
          }
        },
        onEnd: (ev) => {
          this.pressTime = 0;
          this.updatedCurrentTime = 0;
          if (pressInterval) {
            clearInterval(pressInterval);
          }
          this.microPlayerDragger.style.transition = ".1s ease-out";
          let translateValue = 0;
          if (ev.deltaX > 100 && this.pressTime < 1) {
            if (this.microPlayerPosition == 2) {
              this.microPlayerPosition = 1;
              translateValue = 40;
            } else if (this.microPlayerPosition == 1) {
              this.microPlayerPosition = 0;
              translateValue = 0;
            }
          } else if (ev.deltaX < -100 && this.pressTime < 1) {
            if (this.microPlayerPosition == 0) {
              this.microPlayerPosition = 1;
              translateValue = 40;
            } else if (this.microPlayerPosition == 1) {
              this.microPlayerPosition = 2;
              translateValue = 80;
            }
          }
          if (translateValue != 0) {
            this.microPlayerDragger.style.transform = `translateX(${-1 * translateValue
              }vw)`;
          } else {
            this.microPlayerDragger.style.transform = "";
          }
        },
      });

      microDraggerGesture.enable();
      // console.log("gesture enabled");
    }
  },

  methods: {
    updateDesktopLayout() {
      if (typeof window === 'undefined') return;
      this.desktopLayout = window.matchMedia('(min-width: 992px)').matches;
    },
    restoreDesktopMenuCollapsed() {
      if (typeof localStorage === 'undefined') return;
      try {
        this.desktopMenuCollapsed = localStorage.getItem('liga-desktop-menu-collapsed') === '1';
      } catch {
        this.desktopMenuCollapsed = false;
      }
    },
    setDesktopMenuCollapsed(collapsed: boolean) {
      this.desktopMenuCollapsed = collapsed;
      try {
        localStorage.setItem('liga-desktop-menu-collapsed', collapsed ? '1' : '0');
      } catch {
        /* ignore quota / private mode */
      }
      this.emitter?.emit('desktop-menu-collapsed', collapsed);
      if (collapsed) {
        void menuController.close('mainMenu');
      }
    },
    async loadReturnsPendingCount() {
      if (!this.isAuthenticated) {
        this.returnsPendingCount = 0;
        return;
      }
      const authorities = store.getters.account?.authorities as string[] | undefined;
      const hasAdminRole = authorities?.some((a) => a === 'ROLE_ADMIN' || a === 'ROLE_MANAGER');
      if (!hasAdminRole) {
        try {
          const ok = await this.accountService.hasAnyAuthorityAndCheckAuth(['ROLE_ADMIN', 'ROLE_MANAGER']);
          if (!ok) {
            this.returnsPendingCount = 0;
            return;
          }
        } catch {
          this.returnsPendingCount = 0;
          return;
        }
      }
      try {
        this.returnsPendingCount = await eventsService.returnsPendingCount();
      } catch {
        this.returnsPendingCount = 0;
      }
    },
    isActive(tab: string): boolean {
      return this.$route.path.includes(tab);
    },

    navigate(routeName: string): void {
      menuController.close();
      this.$router.push(`/${routeName}`);
    },

    goOfflineAndStopLoading(): void {
      this.globalContext.isLoading = false;
      this.globalContext.offlineMode = true;
      void this.refreshHasOfflineLibraryMusic();
    },

    playNowNavigate(routeName: string): void {
      this.navigate(routeName);
      this.showPlayNow = false;
    },
    playNow() {
      this.playerBar.visible = true;
      this.openPlayList();
      if (this.isMobile) {
        if (!this.audioPlayer.isPlaying) {
          this.emitter.emit("music-player-loaded-list", true);
        }
      } else {
        if (this.audioRef.paused) {
          this.emitter.emit("music-player-loaded-list", true);
        }
      }
      this.showPlayNow = false;
    },

    async downloadProgramsLogo() {
      if (this.globalContext.offlineMode) {
        return;
      }
      // Кэш логотипов на диске только на нативе; на вебе не дергаем API (гость на витрине иначе получал 401).
      if (!Capacitor.isNativePlatform()) {
        return;
      }
      const tokenQuery = await Preferences.get({ key: "jwt" });
      const token = tokenQuery.value?.trim();
      if (!token) {
        return;
      }

      const options = {
        url: `${process.env.VUE_APP_API_URL}api/programs?page=0&size=1000`,
        headers: { Authorization: `Bearer ${token}` },
        readTimeout: 60000,
      };

      try {
        const result = await CapacitorHttp.get(options);
        let data = result.data;
        if (typeof data === "string") {
          try {
            data = JSON.parse(data);
          } catch {
            data = [];
          }
        }
        if (Array.isArray(data) && data.length > 0) {
          const logoService = new LogoService();
          await logoService.downloadAllProgramLogos(data);
        }
      } catch (error) {
        console.error("Failed to download program logos:", error);
      }
    },

    openMenu() {
      this.userLastname = store.getters.account
        ? store.getters.account.lastName
        : "";
      this.userFirstname = store.getters.account
        ? store.getters.account.firstName
        : "";

      if (this.globalContext.offlineMode) {
        menuController.enable(true, "offlineMenu");
        menuController.open("offlineMenu");
      } else {
        this.calendarService.countAllReplacements().then((result) => {
          this.countClassesNeedReplace = result.countNeedReplace;
          this.countClassesNeedAccept = result.countNeedAccept;
          this.globalContext.showMenuNotification = result.countNeedReplace > 0;
        });

        menuController.enable(true, "mainMenu");
        menuController.open("mainMenu");
      }
    },

    centerAction() {
      console.log('Center button clicked');
      
    },
    openSettings() {
      console.log('Settings clicked');
      
    },

    hasAnyAuthority(authorities: any): boolean {
      this.accountService
        .hasAnyAuthorityAndCheckAuth(authorities)
        .then((value) => {
          this.hasAnyAuthorityValue = value;
          if (value) {
            void this.loadReturnsPendingCount();
          }
        });
      return this.hasAnyAuthorityValue;
    },
    canShowSection(sectionKey: AppSectionKey): boolean {
      if (!this.isAuthenticated && !['SHOWCASE', 'SETTINGS', 'SUPPORT'].includes(sectionKey)) {
        return false;
      }
      return this.appSectionService.canAccessSection(sectionKey);
    },
    canShowMusicLibrary(): boolean {
      return (
        this.canShowSection('MUSIC_LIBRARY') &&
        (!this.globalContext.offlineMode || this.globalContext.hasOfflineLibraryMusic)
      );
    },
    async refreshHasOfflineLibraryMusic(): Promise<void> {
      if (!this.isMobile) {
        this.globalContext.hasOfflineLibraryMusic = false;
        return;
      }
      try {
        this.globalContext.hasOfflineLibraryMusic =
          await this.filesystemCustomUtils.hasAnyLibraryMusicOffline();
      } catch {
        this.globalContext.hasOfflineLibraryMusic = false;
      }
    },
    syncMessengerPushSuppress() {
      void syncMessengerPushBannerSuppress(!!this.isMessenger);
    },
    isViewWithMenu() {
      return (
        !this.isLogin &&
        !this.isSignUp &&
          !this.isChangePassword &&
        !this.isResetPassword &&
        !this.isRelease &&
        !this.isReleasePage &&
        !this.isReleaseMusic &&
        !this.isReleaseVideo &&
        !this.isReleaseGuide &&
        !this.isReplacementCandidate &&
        !this.isPlaylistMode &&
        !this.isPlayListView &&
        !this.isProgramFeedback &&
        !this.isProgramFeedbackResults
      );
      // && !this.isBadConnection;
    },
    showReleaseTabs() {
      return (
        !this.isLandscapeMode &&
        (this.isRelease ||
          this.isReleaseMusic ||
          this.isReleaseVideo ||
          this.isReleaseGuide)
      );
    },
    showMainTabs() {
      return (
        (this.isShowcase && this.canShowSection('SHOWCASE')) ||
        ((this.isSkills && this.canShowSection('TRAININGS')) ||
          (this.isExercises && this.canShowSection('EXERCISES')) ||
          (this.isWorkouts && this.canShowSection('WORKOUTS')) ||
          (this.isEducation && this.canShowSection('EDUCATION'))) && !this.isLandscapeMode ||
        (this.isPlaylistList && this.canShowSection('PLAYLIST_LIST')) ||
        (this.isPrograms && this.canShowSection('PROGRAMS')) ||
        (this.isMusicLibrary && this.canShowMusicLibrary()) ||
        // Liga.Chat: нижняя панель только в инбоксе; внутри чатов/инфо/создания — скрыта
        (this.isMessengerInbox && this.canShowSection('MESSENGER'))
      );
    },
    extendPlayerOnTrackName() {
      if (!this.showExtendedPlayer) {
        this.showExtendedPlayer = true;
        this.playerBar.currentMode = PlayerModes.EXTENDED;
      } else if (!this.isFM()) {
        this.showPlayList = true;
        this.playerBar.currentMode = PlayerModes.PLAYLIST;
      }

      if (this.showPlayList) {
        this.getAlbumImage();
      }
    },
    toCompactPlayer() {
      this.playerBar.visible = true;
      this.playerBar.currentMode = PlayerModes.DEFAULT;
      this.playerBar.microMode = false;
      this.showExtendedPlayer = false;
      this.showPlayList = false;
      this.showPlayerDelay = false;
    },
    toExtendedPlayer() {
      this.playerBar.visible = true;
      this.playerBar.currentMode = PlayerModes.EXTENDED;
      this.playerBar.microMode = false;
      this.showExtendedPlayer = true;
      this.showPlayList = false;
      this.showPlayerDelay = false;
    },
    reloadPlaylist(refreshEvent?: CustomEvent) {
      this.emitter.emit("music-player-loaded-list", true);
      if (refreshEvent && refreshEvent.target) {
        if (this.isMobile) {
          this.audioPlayer.ready().then(() => {
            refreshEvent.detail.complete();
            this.audioPlayer.play();
          });
        } else {
          refreshEvent.detail.complete();
        }
      }
    },
    getCurrentTrackNum(): string {
      if (this.playerBar.musicList.length < 1) return "-";

      const trackNum = this.playerBar.currentTrackIdx + 1;
      return trackNum > 9 ? String(trackNum) : `0${trackNum}`;
    },
    openPlayList() {
      this.showPlayList = true;
      this.playerBar.currentMode = PlayerModes.PLAYLIST;
      if (this.showPlayList) {
        this.getAlbumImage();
      }
    },
    isFM(): boolean {
      return this.playerBar.isFM;
    },
    openDelaySettings() {
      this.showPlayerDelay = !this.showPlayerDelay;
    },
    closePlayer() {
      if (this.isMobile) {
          this.audioPlayer.pause();
      } else {
        this.audioRef.pause();
      }
      this.toCompactPlayer();
      this.playerBar.visible = false;
      this.playerBar.playing = false;
      this.playerBar.currentMode = PlayerModes.CLOSED;
    },
    toMicroMode() {
      this.playerBar.visible = false;
      this.playerBar.microMode = true;
      this.playerBar.currentMode = PlayerModes.MICRO;
    },
    playerControls(play: boolean) {
      this.playerBar.playing = play;
      if (play) {
        if (this.isMobile) {
          // this.emitter.emit("music-player-play", true);
          this.audioPlayer.seekTo(this.playerBar.currentPosition).then(() => {
            this.audioPlayer.play();
          });
          this.playerBar.playing = true;
          this.playerBar.paused = false;
        } else {
          if (this.audioRef.currentTime > 0) {
            this.audioRef.play();
          } else {
            this.getAudioTrack().then(() => {
              this.audioRef.load();
            });
          }
        }
      } else {
        if (this.isMobile) {
          // this.emitter.emit("music-player-pause", true);
          this.audioPlayer.pause();
        } else {
          this.audioRef.pause();
        }
      }
    },

    restartAudioPlayer(play?: boolean) {
      this.playerBar.currentTrackCurrentTime = this.mediaUtils.formatTime(0);
      this.playerBar.currentPosition = 0;
      if (this.isMobile) {
        this.audioPlayer.pause();
        if (play) {
          this.audioPlayer.seekTo(this.playerBar.currentPosition).then(() => {
            this.audioPlayer.play();
          });
        }
      } else {
        if (this.audioRef) {
          this.audioRef.pause();
          this.audioRef.currentTime = 0;
          this.audioRef.load();
          if (play) this.audioRef.play();
        }
      }
    },

    async getFmPlaylist(): Promise<void> {
      const tokenQuery = await Preferences.get({ key: "jwt" });
      const token = tokenQuery.value;

      const options = {
        url: `${process.env.VUE_APP_API_URL}api/media-metadata/shuffle-audio`,
        headers: { Authorization: `Bearer ${token}` },
        readTimeout: 60000,
      };

      CapacitorHttp.get(options).then((response) => {
        this.playerBar.musicList = response.data;
        if (this.playerBar.musicList.length > 0) {
          this.playerBar.isFM = true;
          this.playerBar.playlistName = "liga.FM";
          this.emitter.emit("music-player-loaded-list", true);
        }
      });

      this.showPlayNow = false;
    },

    addMobileTrack(selectedTrack: GoogleMedia): Promise<boolean> {
      return new Promise<boolean>((resolve) => {
        this.getAudioTrack(selectedTrack.id, selectedTrack.mimeType).then(
          (trackPath) => {
            const albumArt = this.playerAlbumImage
              || (this.playerBar.playlistImageDir && this.playerBar.playlistImage
                ? `${this.playerBar.playlistImageDir}/${this.playerBar.playlistImage}`
                : "");
            this.audioPlayer
              .addItem({
                isStream: false,
                trackId: selectedTrack.id,
                assetUrl: trackPath,
                artist: "Liga.Team",
                albumArt,
                album: this.playerBar.playlistName,
                title: this.mediaUtils.getTrackName(selectedTrack),
              })
              .then(() => {
                resolve(true);
              })
              .catch(() => {
                resolve(false);
              });
          }
        );
      });
    },

    async addMobileTracks(
      selectedTracks: Array<GoogleMedia>
    ): Promise<Array<AudioTrack>> {
      const mobileTracks = new Array<AudioTrack>();
      for (let index = 0; index < selectedTracks.length; index++) {
        const selectedTrack = selectedTracks[index];
        const trackPath = await this.getAudioTrack(
          selectedTrack.id,
          selectedTrack.mimeType
        );
        let albumArt: string;
        if (this.playerBar.fixedAlbumArtUrl) {
          albumArt = this.playerBar.fixedAlbumArtUrl;
        } else if (this.playerBar.programShortName) {
          albumArt = await this.logoService.getProgramLogo(this.playerBar.programShortName);
        } else {
          albumArt = await this.getTrackImageUri(
            `${this.playerBar.playlistImageDir}/${this.playerBar.playlistImage}`
          );
        }

        mobileTracks.push({
          isStream: false,
          trackId: selectedTrack.id,
          assetUrl: trackPath,
          artist: "Liga.Team",
          albumArt,
          album: this.playerBar.playlistName,
          title: this.mediaUtils.getTrackName(selectedTrack),
        });
      }
      return mobileTracks;
    },

    getTrackImageUri(path: string): Promise<string> {
      return new Promise<string>((resolve) => {
        Filesystem.getUri({
          path: path,
          directory: Directory.Data,
        })
          .then((result) => {
            resolve(result.uri.replaceAll("file://", ""));
          })
          .catch(() => {
            resolve("");
          });
      });
    },

    selectTrack(idx?: number) {
      if (typeof idx !== "undefined") this.playerBar.currentTrackIdx = idx;
      this.playerBar.currentTrackId =
        this.playerBar.musicList[this.playerBar.currentTrackIdx].id;

      if (this.isMobile) {
        this.audioPlayer.selectTrackById(this.playerBar.currentTrackId);
      } else {
        this.getAudioTrack().then(() => {
          this.restartAudioPlayer();
        });
      }
    },

    selectTrackAndPlay(idx?: number) {
      if (typeof idx !== "undefined") this.playerBar.currentTrackIdx = idx;

      this.playerBar.currentTrackId =
        this.playerBar.musicList[this.playerBar.currentTrackIdx].id;

      if (this.isMobile) {
        this.audioPlayer.playTrackById(this.playerBar.currentTrackId);
      } else {
        this.getAudioTrack().then(() => {
          this.playerBar.playing = true;
          this.restartAudioPlayer(true);
        });
      }
    },

    nextAudioTrack() {
      ++this.playerBar.currentTrackIdx;
      if (
        this.playerBar.currentTrackIdx >
        this.playerBar.musicList.length - 1
      ) {
        this.playerBar.currentTrackIdx = 0;
      }
      this.playerBar.currentTrackId =
        this.playerBar.musicList[this.playerBar.currentTrackIdx].id;

      if (this.isMobile) {
        this.audioPlayer.skipForward();
      } else {
        this.selectTrack(this.playerBar.currentTrackIdx);
      }
    },

    playBackTrack() {
      //seek to the start of track
      if (this.isMobile) {
        this.playerBar.currentPosition = 0;
        this.playerBar.currentTrackCurrentTime = this.mediaUtils.formatTime(
            this.playerBar.currentPosition
        );
        this.audioPlayer.seekTo(this.playerBar.currentPosition);
      } else {
        this.audioRef.currentTime = 0;
      }
    },

    prevAudioTrack() {
      if (this.playerBar.currentPosition > 20) {
        //seek to the start of track
        if (this.isMobile) {
          this.playerBar.currentPosition = 0;
          this.playerBar.currentTrackCurrentTime = this.mediaUtils.formatTime(
            this.playerBar.currentPosition
          );
          this.audioPlayer.seekTo(this.playerBar.currentPosition);
        } else {
          this.audioRef.currentTime = 0;
        }
      } else {
        //switch to the previous track
        --this.playerBar.currentTrackIdx;
        if (this.playerBar.currentTrackIdx < 0)
          this.playerBar.currentTrackIdx = 0;
        this.playerBar.currentTrackId =
          this.playerBar.musicList[this.playerBar.currentTrackIdx].id;

        if (this.isMobile) {
          this.audioPlayer.skipBack();
        } else {
          this.selectTrackAndPlay(this.playerBar.currentTrackIdx);
        }
      }
    },

    changeCurrentPosition(delta: number): Promise<boolean> {
      return new Promise<boolean>((resolve) => {
        if (this.isMobile) {
          this.playerBar.currentPosition = Math.floor(
            this.playerBar.currentPosition + delta
          );
          this.playerBar.currentTrackCurrentTime = this.mediaUtils.formatTime(
            this.playerBar.currentPosition
          );
          this.audioPlayer.seekTo(this.playerBar.currentPosition).then(() => {
            resolve(true);
          });
        } else {
          this.audioRef.currentTime = this.audioRef.currentTime + delta;
          resolve(true);
        }
      });
    },

    setCurrentPosition(value: number): Promise<boolean> {
      return new Promise<boolean>((resolve) => {
        if (this.isMobile) {
          this.playerBar.currentPosition = Math.floor(value);
          this.playerBar.currentTrackCurrentTime = this.mediaUtils.formatTime(
            this.playerBar.currentPosition
          );
          this.audioPlayer.seekTo(value).then(() => {
            resolve(true);
          });
        } else {
          this.audioRef.currentTime = value;
          resolve(true);
        }
      });
    },

    async getAudioTrack(
      trackId?: string,
      trackMimeType?: string
    ): Promise<string> {
      const tokenQuery = await Preferences.get({ key: "jwt" });
      const token = tokenQuery.value;

      if (this.playerBar.musicList.length < 1) return "";

      const getTrackId = trackId
        ? trackId
        : this.playerBar.musicList[this.playerBar.currentTrackIdx].id;
      const getTrackMimeType = trackMimeType
        ? trackMimeType
        : this.playerBar.musicList[this.playerBar.currentTrackIdx].mimeType;

      const isServerTrack = getTrackId.startsWith("releases/");
      const isLibraryMusicTrack = getTrackId.startsWith("library_music/");

      if (
        this.isMobile &&
        isLibraryMusicTrack &&
        this.playerBar.offlineDirectory
      ) {
        try {
          const relPath =
            this.filesystemCustomUtils.relativePathWithMimeExtension(
              getTrackId,
              getTrackMimeType
            );
          const fullPath = `${this.playerBar.offlineDirectory}/${relPath}`;
          const info = await Filesystem.stat({
            path: fullPath,
            directory: Directory.Data,
          });
          if (info.size > 0) {
            const res = await Filesystem.getUri({
              path: fullPath,
              directory: Directory.Data,
            });
            this.trackPath = `${res.uri}`;
            return this.trackPath;
          }
        } catch {
          /* fall through to stream / other sources */
        }
      }

      const listTrack = this.playerBar.musicList.find(
        (m) => m.id === getTrackId
      );
      const trackMarkedOffline =
        !!listTrack?.isOffline && !!this.playerBar.offlineDirectory;
      const useLocalFiles =
        this.playerBar.offline ||
        this.globalContext.offlineMode ||
        trackMarkedOffline;

      if (this.isMobile && useLocalFiles && this.playerBar.offlineDirectory) {
        try {
          const relPath =
            this.filesystemCustomUtils.relativePathWithMimeExtension(
              getTrackId,
              getTrackMimeType
            );
          const res = await Filesystem.getUri({
            path: `${this.playerBar.offlineDirectory}/${relPath}`,
            directory: Directory.Data,
          });
          this.trackPath = `${res.uri}`;
          return this.trackPath;
        } catch {
          /* fall through */
        }
      }

      if (isServerTrack || isLibraryMusicTrack) {
        const streamBase = isLibraryMusicTrack ? "library-music" : "releases";
        const options = {
          url: `${process.env.VUE_APP_API_URL}api/${streamBase}/stream-request?path=${encodeURIComponent(getTrackId)}`,
          headers: { Authorization: `Bearer ${token}` },
          readTimeout: 60000,
        };
        try {
          const response = await CapacitorHttp.get(options);
          let data = response.data;
          if (typeof data === "string") {
            try {
              data = JSON.parse(data);
            } catch {
              /* keep string */
            }
          }
          if (data && data.streamUrl) {
            this.trackPath = normalizeReleaseStreamUrl(data.streamUrl);
          } else {
            this.trackPath = `${process.env.VUE_APP_API_URL}api/${streamBase}/stream?path=${encodeURIComponent(getTrackId)}`;
          }
          return this.trackPath;
        } catch {
          this.trackPath = `${process.env.VUE_APP_API_URL}api/${streamBase}/stream?path=${encodeURIComponent(getTrackId)}`;
          return this.trackPath;
        }
      }

      const options = {
        url: `${process.env.VUE_APP_API_URL
          }api/google/media/storage/${getTrackId}.${this.mimeExtensions.get(
            getTrackMimeType
          )}`,
        headers: { Authorization: `Bearer ${token}` },
        readTimeout: 60000,
      };
      if (this.globalContext.musicBeta) {
        try {
          const response = await CapacitorHttp.get(options);
          if (response.data) {
            this.trackPath = `${process.env.VUE_APP_MEDIA_URL
              }media/${getTrackId}.${this.mimeExtensions.get(
                getTrackMimeType
              )}`;
          } else {
            this.trackPath = `${process.env.VUE_APP_API_URL}api/google/music/${getTrackId}`;
          }
          return this.trackPath;
        } catch {
          this.trackPath = `${process.env.VUE_APP_API_URL}api/google/music/${getTrackId}`;
          return this.trackPath;
        }
      }
      try {
        const response = await CapacitorHttp.get(options);
        if (this.isMobile && response.data) {
          this.trackPath = `${process.env.VUE_APP_MEDIA_URL
            }media/${getTrackId}.${this.mimeExtensions.get(
              getTrackMimeType
            )}`;
        } else {
          this.trackPath = `${process.env.VUE_APP_API_URL}api/google/music/${getTrackId}`;
        }
        return this.trackPath;
      } catch {
        this.trackPath = `${process.env.VUE_APP_API_URL}api/google/music/${getTrackId}`;
        return this.trackPath;
      }
    },

    rangeDragging(value: string) {
      this.playerBar.currentTrackCurrentTime = this.mediaUtils.formatTime(
        Number(value)
      );
    },
    rangeDragStart() {
      if (!this.isMobile) {
        this.audioRef.pause();
      }
    },
    rangeDragEnd() {
      if (this.isMobile) {
        this.audioPlayer.seekTo(Math.floor(this.playerBar.currentPosition));
      } else {
        this.audioRef.currentTime = this.playerBar.currentPosition;
        this.playerBar.currentTrackCurrentTime = this.mediaUtils.formatTime(
          this.playerBar.currentPosition
        );
        this.audioRef.play();
      }
    },

    getAlbumImage() {
      if (this.playerBar.fixedAlbumArtUrl) {
        this.playerAlbumImage = this.playerBar.fixedAlbumArtUrl;
        return;
      }
      if (this.playerBar.programShortName) {
        this.logoService.getProgramLogo(this.playerBar.programShortName).then((url) => {
          this.playerAlbumImage = url;
        });
        return;
      }
      if (!this.playerBar.playlistImage || this.playerBar.playlistImage == "")
        return;

      if (this.globalContext.offlineMode) {
        let storedImageExists = false;
        Filesystem.readdir({
          path: this.playerBar.playlistImageDir,
          directory: Directory.Data,
        }).then((response) => {
          storedImageExists = response.files.length > 0;

          if (storedImageExists) {
            Filesystem.getUri({
              path: `${this.playerBar.playlistImageDir}/${this.playerBar.playlistImage}`,
              directory: Directory.Data,
            }).then((storedImage) => {
              this.playerAlbumImage = Capacitor.convertFileSrc(storedImage.uri);
            });
          }
        });
      } else {
        Preferences.get({ key: "jwt" }).then((tokenQuery) => {
          const baseUrl = process.env.VUE_APP_API_URL || process.env.VUE_APP_API_EXT_URL || "";
          const shortName = (this.playerBar.playlistImage || "").replace(/\.(png|jpg|jpeg)$/i, "");
          if (shortName) {
            this.logoService.getProgramLogo(shortName).then((url) => {
              this.playerAlbumImage = url;
            });
          } else {
            CapacitorHttp.get({
              url: `${baseUrl}api/google/file/base64/name/${this.playerBar.playlistImage}`,
              headers: { Authorization: `Bearer ${tokenQuery.value}` },
              readTimeout: 60000,
            }).then((response) => {
              this.playerAlbumImage = `data:image/jpg;base64,${response.data}`;
            });
          }
        });
      }
    },

    async checkAppUpdate() {
      let url: string = STORE_LINKS.google;
      if (isPlatform("ios")) {
        url = STORE_LINKS.apple;
      } else if (isPlatform("android")) {
        try {
          const { provider } = await HmsPush.getPushProvider();
          if (provider === "HMS") url = STORE_LINKS.huawei;
        } catch {
          url = STORE_LINKS.google;
        }
      } else {
        return;
      }
      await Browser.open({ url }).catch((err) => {
        console.log(err);
      });
    },

    async openSupportChannelMenu() {
      await menuController.close();
      this.showSupportChannelModal = true;
    },

    async openInternalSupportChat() {
      this.showSupportChannelModal = false;
      if (!this.isAuthenticated) {
        this.$router.push('/login?redirect=/messenger');
        return;
      }
      const chat = await this.messengerService.support();
      this.$router.push({ name: 'MessengerChat', params: { id: chat.id } });
    },

    async checkMessengerOnboarding() {
      if (!this.isAuthenticated || !this.canShowSection('MESSENGER')) {
        return;
      }
      // Не открывать Liga.Chat онбординг параллельно с privacy/update/appearance/key-backup.
      if (!this.privacyConsentCheckDone || !this.blockingQueueSettled || this.anyBlockingModalOpen?.()) {
        this.messengerOnboardingDeferred = true;
        return;
      }
      try {
        const consent = await Preferences.get({ key: LEGAL.privacyConsentKey });
        if (consent.value !== 'true') {
          this.messengerOnboardingDeferred = true;
          return;
        }
        if (this.anyBlockingModalOpen?.()) {
          this.messengerOnboardingDeferred = true;
          return;
        }
        const privacy = await this.messengerService.getPrivacy();
        if (this.anyBlockingModalOpen?.()) {
          this.messengerOnboardingDeferred = true;
          return;
        }
        this.openMessengerOnboarding(!privacy.onboardingSeen);
        this.messengerOnboardingDeferred = false;
      } catch (error) {
        console.warn('Messenger onboarding check failed', error);
      }
    },

    async flushDeferredMessengerOnboarding() {
      if (this.anyBlockingModalOpen?.()) {
        this.messengerOnboardingDeferred = true;
        return;
      }
      await this.checkMessengerOnboarding();
    },

    /** После privacy/update/appearance: сначала deferred key-backup, потом onboarding. */
    async flushDeferredMessengerQueue() {
      if (!this.blockingQueueSettled) {
        return;
      }
      if (this.messengerKeyBackupDeferred && this.messengerKeyBackupBlob) {
        if (this.anyBlockingModalOpen?.()) {
          return;
        }
        this.messengerKeyBackupDeferred = false;
        this.openMessengerKeyBackupRestore();
        return;
      }
      await this.flushDeferredMessengerOnboarding();
    },

    openMessengerOnboarding(open: boolean) {
      this.showMessengerOnboarding = open;
      if (this.messengerOnboardingBlocking !== undefined) {
        this.messengerOnboardingBlocking = open;
      }
    },

    openMessengerKeyBackupRestore() {
      this.showMessengerKeyBackupRestore = true;
      if (this.messengerKeyBackupBlocking !== undefined) {
        this.messengerKeyBackupBlocking = true;
      }
    },

    async startMessengerUnreadTracking() {
      if (!this.isAuthenticated || !this.canShowSection('MESSENGER')) {
        return;
      }
      await refreshMessengerUnread(this.messengerService);
      void hydrateMessengerOutbox();
      void this.bootstrapMessengerCrypto();
      this.unsubscribeMessengerRealtime?.();
      this.unsubscribeMessengerRealtime = subscribeMessengerRealtime(event => {
        void refreshMessengerUnread(this.messengerService);
        if (event?.type === 'UNREAD_COUNT') {
          const chatId = Number(event.payload ?? event.chatId);
          if (Number.isFinite(chatId) && chatId !== 0) {
            void clearDeliveredMessengerNotifications(chatId);
          }
        }
        if (event?.type === 'DEVICE_REGISTERED') {
          // Устройство с ключами раздаёт wraps; устройство без ключей ждёт CHAT_KEYS_UPDATED.
          scheduleRedistributeKnownChatKeys();
          invalidateChatKeyMiss();
          notifyMessengerLocalEvent({ type: 'CHAT_KEYS_MAYBE_READY', deviceId: event.deviceId });
        }
        if (event?.type === 'CHAT_KEYS_UPDATED') {
          invalidateChatKeyMiss(Number(event.chatId) || undefined);
          notifyMessengerLocalEvent({
            type: 'CHAT_KEYS_MAYBE_READY',
            chatId: event.chatId,
            deviceId: event.deviceId,
          });
        }
      });
    },

    async bootstrapMessengerCrypto() {
      try {
        const hasLocal = await hasLocalMessengerIdentity();
        let backup: IMessengerKeyBackup = { exists: false };
        try {
          backup = await this.messengerService.getKeyBackup();
        } catch (error) {
          console.warn('Messenger key backup status failed', error);
        }
        setServerKeyBackupExists(!!backup.exists);
        if (!hasLocal && backup.exists) {
          this.messengerKeyBackupBlob = backup;
          // Не открывать ion-modal сразу после логина — ждём очередь privacy/update/appearance.
          this.messengerKeyBackupDeferred = true;
          if (this.blockingQueueSettled && !this.anyBlockingModalOpen?.()) {
            void this.flushDeferredMessengerQueue();
          }
          return;
        }
        if (!hasLocal) {
          allowMessengerIdentityCreate();
        }
        await ensureMessengerCryptoReady();
        scheduleRedistributeKnownChatKeys();
      } catch (error) {
        console.warn('Messenger E2E device register failed', error);
      }
    },

    onMessengerKeyBackupRestored() {
      this.showMessengerKeyBackupRestore = false;
      if (this.messengerKeyBackupBlocking !== undefined) {
        this.messengerKeyBackupBlocking = false;
      }
      this.messengerKeyBackupBlob = null;
      this.messengerKeyBackupDeferred = false;
      setServerKeyBackupExists(true);
      scheduleRedistributeKnownChatKeys();
      void this.flushDeferredMessengerOnboarding();
    },

    onMessengerKeyBackupRestoreSkipped() {
      this.showMessengerKeyBackupRestore = false;
      if (this.messengerKeyBackupBlocking !== undefined) {
        this.messengerKeyBackupBlocking = false;
      }
      this.messengerKeyBackupBlob = null;
      this.messengerKeyBackupDeferred = false;
      allowMessengerIdentityCreate();
      void ensureMessengerCryptoReady()
        .then(() => scheduleRedistributeKnownChatKeys())
        .catch(error => console.warn('Messenger E2E device register failed', error));
      void this.flushDeferredMessengerOnboarding();
    },

    closeMessengerKeyBackupRestore() {
      this.showMessengerKeyBackupRestore = false;
      if (this.messengerKeyBackupBlocking !== undefined) {
        this.messengerKeyBackupBlocking = false;
      }
      void this.flushDeferredMessengerOnboarding();
    },

    stopMessengerUnreadTracking() {
      this.unsubscribeMessengerRealtime?.();
      this.unsubscribeMessengerRealtime = null;
    },

    closeMessengerOnboarding() {
      this.openMessengerOnboarding(false);
    },
    async openExternalSupportChannel(url: string) {
      this.showSupportChannelModal = false;
      if (Capacitor.isNativePlatform()) {
        await Browser.open({ url }).catch((err) => console.error("Open support channel:", err));
      } else {
        window.open(url, "_blank", "noopener,noreferrer");
      }
    },
  },
});
</script>

<style scoped>
.menu-notification-flag {
  background: var(--ion-color-danger);
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.logo {
  margin: 1em 0.5em 0.5em 1em;
  display: flex;
  flex-flow: column;
  align-content: center;
}

.app-icon {
  color: var(--liga-chrome-text);
  margin-bottom: 0.05em;
}

ion-fab {
  margin: 5vh 3vw 0 3vw;
  z-index: 1000;
}

ion-app.app-desktop-layout > ion-fab[slot="fixed"] {
  display: none !important;
}

ion-fab-button {
  --background: transparent;
  --background-hover: transparent;
  --background-activated: transparent;
  --background-focused: transparent;
  --box-shadow: none;
  width: 8vh;
  height: 8vh;
}

/* Фон задаёт .modern-tab-bar (токены темы); не форсируем тёмный */
ion-tab-bar {
  --background: transparent;
  background: transparent;
}

.help-button {
  --background: transparent;
  --background-hover: transparent;
  --background-activated: transparent;
  --background-focused: transparent;
  --box-shadow: none;
}

.help-button ion-icon {
  color: var(--liga-chrome-text);
  font-size: 1.3em;
}

.menu-list {
  background: transparent !important;
  padding: 12px 12px 20px;
}

ion-menu {
  --background: var(--liga-menu-panel-solid, #14121c);
}

ion-menu::part(container) {
  /* Панель непрозрачная — иначе контент страницы грязно просвечивает */
  background: var(--liga-menu-panel-bg, linear-gradient(180deg, #1a1626 0%, #14121c 55%, #100e16 100%));
  border-right: 1px solid var(--liga-float-glass-border, rgba(255, 255, 255, 0.14));
  box-shadow: var(--liga-float-glass-shadow, 0 8px 28px rgba(0, 0, 0, 0.28));
}

ion-menu ion-title,
ion-menu ion-label {
  color: var(--liga-chrome-text, #fff);
}

.menu-header-background {
  --background: transparent;
  background:
    var(--liga-app-header-shine),
    var(--liga-app-header-gradient);
}

.menu-collapse-btn {
  position: absolute;
  top: calc(10px + max(env(safe-area-inset-top, 0px), var(--ion-safe-area-top, 0px), 20px));
  right: 10px;
  z-index: 3;
  width: 36px;
  height: 36px;
  border: 1px solid var(--liga-float-glass-border, rgba(255, 255, 255, 0.18));
  border-radius: 12px;
  background: var(--liga-float-glass-bg, rgba(255, 255, 255, 0.08));
  color: var(--liga-chrome-text, #fff);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
}

.menu-collapse-btn ion-icon {
  font-size: 1.15rem;
}

.menu-collapse-btn:hover {
  background: var(--liga-float-glass-bg-strong, rgba(255, 255, 255, 0.14));
}

.desktop-menu-expand-btn {
  position: fixed;
  top: 18px;
  left: 12px;
  z-index: 10000;
  width: 44px;
  height: 44px;
  border: 1px solid var(--liga-float-glass-border, rgba(255, 255, 255, 0.18));
  border-radius: 14px;
  background: var(--liga-float-glass-bg-strong, rgba(30, 28, 40, 0.88));
  color: var(--liga-chrome-text, #fff);
  box-shadow: var(--liga-float-glass-shadow, 0 8px 24px rgba(0, 0, 0, 0.28));
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
}

.desktop-menu-expand-btn ion-icon {
  font-size: 1.35rem;
}

.desktop-menu-expand-btn:hover {
  filter: brightness(1.08);
}

.menu-header-modern {
  min-height: 0;
  /* fallback 20px: на native inset иногда 0 до StatusBar overlay */
  padding: calc(14px + max(env(safe-area-inset-top, 0px), var(--ion-safe-area-top, 0px), 20px)) 14px 14px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  gap: 0;
  position: relative;
  overflow: hidden;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: none;
}

.menu-header-modern::after {
  content: "";
  position: absolute;
  inset: 0;
  background: radial-gradient(ellipse 80% 60% at 100% 0%, rgba(255, 255, 255, 0.1) 0%, transparent 55%);
  pointer-events: none;
  z-index: 0;
}

.menu-header-logo-bg {
  position: absolute;
  right: -18px;
  top: 50%;
  transform: translateY(-50%);
  height: 118%;
  width: auto;
  max-width: none;
  object-fit: contain;
  opacity: 0.14;
  pointer-events: none;
  user-select: none;
  z-index: 0;
  filter: drop-shadow(0 2px 10px rgba(0, 0, 0, 0.2));
}
.menu-header-logo-bg--light {
  opacity: 0.1;
}

.menu-header-profile-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  position: relative;
  z-index: 1;
  min-height: 40px;
  width: 100%;
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
  border-radius: 10px;
  transition: background-color 0.15s ease;
}

.menu-header-profile-row:disabled {
  cursor: default;
}

.menu-header-profile-row:not(:disabled):active {
  background: rgba(255, 255, 255, 0.08);
}

.menu-header-offline.menu-header-modern {
  min-height: 0;
  padding-bottom: 12px;
}

.menu-header-avatar {
  width: 40px !important;
  height: 40px !important;
  flex-shrink: 0;
  border: 1.5px solid rgba(255, 255, 255, 0.4);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.menu-header-profile-text {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1px;
}

.menu-header-user-label {
  margin: 0;
  color: #fff !important;
  font-weight: 650;
  font-size: 0.92rem;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.menu-header-profile-link {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  align-self: flex-start;
  margin: 0;
  padding: 0;
  color: rgba(255, 255, 255, 0.82);
  font-size: 0.78rem;
  line-height: 1.2;
}

.menu-header-profile-row:not(:disabled):hover .menu-header-profile-link {
  color: #fff;
}

.menu-header-profile-chevron {
  font-size: 0.85rem;
  opacity: 0.8;
}

.menu-header-guest-actions {
  position: relative;
  z-index: 1;
  padding-top: 0;
}

.menu-header-login-btn {
  margin: 0;
  --background: rgba(255, 255, 255, 0.95);
  --background-activated: rgba(255, 255, 255, 0.85);
  --color: #2a2138;
  --border-radius: 12px;
  font-weight: 700;
  text-transform: none;
  letter-spacing: 0.02em;
  min-height: 40px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);
}

.menu-avatar {
  align-self: flex-start;
  display: flex;
  --inner-padding-top: 5px;
  --inner-padding-bottom: 5px;
}

.menu-avatar ion-avatar {
  width: 55px !important;
  height: 55px !important;
  margin-inline-end: 15px !important;
}

.menu-avatar ion-label {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.menu-user-account {
  color: white;
  font-family: 'Montserrat',
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-size: 0.7em;
}

.menu-user-name {
  color: var(--ion-color-orange);
  font-family: 'Montserrat',
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-weight: bold;
  font-size: 1em;
  white-space: initial;
}

.menu-header-fake {
  width: 100%;
  height: 20px;
}

.menu-footer {
  --background: transparent;
  font-size: 0.9em !important;
  border-top: 1px solid var(--liga-float-glass-border, rgba(255, 255, 255, 0.14));
}
/* Футер меню — плотный, в тон панели */
ion-menu .menu-footer ion-toolbar.app-footer-style {
  --background: var(--liga-menu-panel-solid, rgba(16, 14, 22, 0.98)) !important;
  background: var(--liga-menu-panel-solid, rgba(16, 14, 22, 0.98)) !important;
  --color: var(--liga-chrome-text, rgba(255, 255, 255, 0.95));
  color: var(--liga-chrome-text, rgba(255, 255, 255, 0.95));
  padding-top: 8px;
}
.menu-footer ion-title.menu-footer {
  color: rgba(255, 255, 255, 0.95);
}
.menu-footer ion-title.menu-footer-version {
  margin-top: 6px;
  padding-top: 2px;
  padding-bottom: 8px;
  font-size: 0.9em;
}
.menu-footer-links {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.25em;
  padding: 0 8px 4px;
  font-size: 0.85em;
}
.menu-footer-link {
  color: #ffb380;
  cursor: pointer;
  text-decoration: none;
}
.menu-footer-link:hover {
  color: #ffcc99;
  text-decoration: underline;
}
.menu-footer-sep {
  color: rgba(255, 255, 255, 0.5);
  user-select: none;
}
.menu-footer-payee {
  margin: 0 8px 0;
  font-size: 0.8em;
  color: rgba(255, 255, 255, 0.9);
  text-align: center;
}
.menu-footer-payee .menu-footer-link {
  color: #ffb380;
}
.menu-footer-payee .menu-footer-link:hover {
  color: #ffcc99;
}

.menu-content {
  --background: transparent;
  background: transparent;
}

ion-menu:not(.split-pane-side) .menu-content {
  width: unset !important;
}

ion-split-pane ion-menu.split-pane-side .menu-content {
  width: 100% !important;
}

.menu-item {
  cursor: pointer;
  /* Glass-look на непрозрачной панели: светлая кайма + мягкий fill, без blur сквозь страницу */
  --background: var(--liga-surface, rgba(255, 255, 255, 0.07)) !important;
  --background-hover: rgba(255, 255, 255, 0.11) !important;
  --background-activated: rgba(255, 255, 255, 0.09) !important;
  --border-color: transparent;
  --inner-border-width: 0;
  --border-radius: 16px;
  --min-height: 50px;
  --padding-start: 12px;
  --padding-end: 12px;
  margin: 0 4px 8px;
  color: var(--liga-chrome-text, #fff);
  border: 1px solid var(--liga-surface-border, rgba(255, 255, 255, 0.14));
  border-radius: 16px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);
  overflow: hidden;
  transition: transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease, background 0.15s ease;
}

html.liga-theme-light .menu-item {
  --background-hover: rgba(0, 0, 0, 0.05) !important;
  --background-activated: rgba(0, 0, 0, 0.04) !important;
  box-shadow: 0 4px 14px rgba(20, 16, 40, 0.08);
}

.menu-item::part(native) {
  border-radius: 16px;
  background: transparent;
}

.menu-item:last-child {
  --border-style: unset !important;
}

.menu-item .app-icon {
  color: var(--liga-chrome-text, rgba(255, 255, 255, 0.92));
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid var(--liga-surface-border, rgba(255, 255, 255, 0.12));
  padding: 8px;
  border-radius: 12px;
  margin-inline-end: 4px;
  margin-bottom: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
}

html.liga-theme-light .menu-item .app-icon {
  background: rgba(0, 0, 0, 0.05);
}

.menu-label {
  margin-left: 0.35rem;
  margin-top: 0;
  font-size: 0.98rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  color: var(--liga-chrome-text, #fff);
}

html.liga-theme-light .menu-footer-link {
  color: #c44a42;
}
html.liga-theme-light .menu-footer-payee {
  color: rgba(26, 26, 34, 0.75);
}
html.liga-theme-light .menu-footer ion-title.menu-footer,
html.liga-theme-light .menu-footer ion-title.menu-footer-version {
  color: rgba(26, 26, 34, 0.85);
}

.menu-returns-badge {
  --background: #ffc107;
  --color: #1a1a1a;
  font-weight: 700;
  min-width: 22px;
  border-radius: 11px;
}

.menu-list ion-item-divider {
  --background: transparent;
  --color: rgba(255, 255, 255, 0.55);
  min-height: 40px;
  margin: 8px 8px 4px;
  padding-inline: 4px 8px;
  border: none;
}

.menu-section-label {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  white-space: normal;
  line-height: 1.25;
  color: rgba(255, 255, 255, 0.5) !important;
}

.menu-fab-button {
  z-index: 1000;
}

.selected-route {
  --background: rgba(235, 89, 82, 0.22) !important;
  border-color: rgba(235, 89, 82, 0.45);
  box-shadow:
    inset 3px 0 0 0 var(--ion-color-orange),
    0 4px 14px rgba(0, 0, 0, 0.2);
}

.selected-route .menu-label,
.selected-route .app-icon {
  color: #fff !important;
}

.selected-route .app-icon {
  background: rgba(235, 89, 82, 0.32);
  border-color: rgba(235, 89, 82, 0.4);
}

/* Светлая тема: активный пункт — тёмный текст на коралловом tint */
html.liga-theme-light .selected-route {
  --background: rgba(235, 89, 82, 0.18) !important;
  border-color: rgba(235, 89, 82, 0.55);
}
html.liga-theme-light .selected-route .menu-label,
html.liga-theme-light .selected-route .app-icon {
  color: #1a1a22 !important;
}
html.liga-theme-light .selected-route .app-icon {
  background: rgba(235, 89, 82, 0.22);
  color: #1a1a22 !important;
}
html.liga-theme-light .menu-section-label {
  color: rgba(26, 26, 34, 0.45) !important;
}
html.liga-theme-light .menu-list ion-item-divider {
  --color: rgba(26, 26, 34, 0.45);
}

.music-player-container {
  --liga-player-above-tabs: calc(88px + env(safe-area-inset-bottom, 0px) + var(--liga-browser-chrome-bottom, 0px));
  min-height: 60px !important;
  max-height: 100vh;
  /* Не 100vw: внутри split-pane иначе шире колонки и уезжает вправо */
  width: auto;
  max-width: none;
  background: transparent;
  padding: 10px 0 0;
  position: absolute;
  /* Над floating glass tab-bar */
  bottom: var(--liga-player-above-tabs);
  left: 15px;
  right: 15px;
  border-radius: 20px;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  z-index: 12;
  box-sizing: border-box;
}

.music-player-bottom-container {
  bottom: calc(16px + env(safe-area-inset-bottom, 0px) + var(--liga-browser-chrome-bottom, 0px)) !important;
}

.music-player-desktop {
  left: 50%;
  right: auto;
  transform: translateX(-50%);
  width: min(720px, calc(100% - 48px));
  max-width: min(720px, calc(100% - 48px));
}

ion-split-pane {
  --side-max-width: 300px;
  --side-min-width: 280px;
  --border: 1px solid rgba(255, 255, 255, 0.08);
  height: 100%;
  min-height: 100vh;
}

ion-split-pane ion-menu {
  --width: 280px;
  --max-width: 300px;
}

.app-main-shell {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  position: relative;
}

.app-main-shell ion-tabs {
  flex: 1;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  position: relative;
  overflow: hidden;
}

@media (min-width: 1024px) {
  ion-split-pane .menu-label {
    font-size: 1.05rem;
  }

  ion-split-pane .menu-item {
    --min-height: 52px;
  }

  ion-split-pane .menu-item .app-icon {
    font-size: 1.35rem;
    padding: 9px;
  }
}

.w-full-player {
  width: 100%;
  height: 80vh;
  background: var(--liga-float-glass-bg-strong);
  border-radius: 16px;
  box-shadow: var(--liga-float-glass-shadow);
  backdrop-filter: var(--liga-float-glass-blur);
  -webkit-backdrop-filter: var(--liga-float-glass-blur);
  border: 1px solid var(--liga-float-glass-border);
  color: var(--liga-chrome-text);
}
.w-full-player-header {
  margin-top: 1em;
  padding: 0 5%;
  display: flex;
}
.w-full-player-header img {
  height: 85%;
  width: 20%;
  border-radius: 15px;
  align-self: flex-start;
  object-fit: contain;
}

.micro-player-container {
  height: 60px;
  width: 56px;
  background: transparent;
  position: absolute;
  bottom: calc(88px + env(safe-area-inset-bottom, 0px));
  left: 12px;
  padding: 0;
  display: flex;
  flex-flow: column;
  z-index: 12;
  box-sizing: border-box;
  transition: width 0.35s ease, left 0.35s ease, right 0.35s ease;
}
.micro-player-container-ext {
  left: 12px;
  right: 12px;
  width: auto !important;
  max-width: none;
  transition: width 0.35s ease, left 0.35s ease, right 0.35s ease;
}

.micro-player {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  background: var(--liga-float-glass-bg-strong);
  box-shadow: var(--liga-float-glass-shadow);
  backdrop-filter: var(--liga-float-glass-blur);
  -webkit-backdrop-filter: var(--liga-float-glass-blur);
  border: 1px solid var(--liga-float-glass-border);
  display: flex;
  align-items: center;
  padding: 0.5em 1em;
  position: relative;
  box-sizing: border-box;
  overflow: hidden;
  min-width: 0;
  color: var(--liga-chrome-text);
}
.w-track-index {
  font-family: 'Montserrat';
  font-size: 2.5em;
  font-weight: bold;
  color: var(--liga-chrome-text-muted);
  opacity: 0.35;
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  flex: 0 0 auto;
}
.w-track-index-ext {
  width: 64px;
  min-width: 56px;
  max-width: 72px;
  height: 100%;
  flex: 0 0 auto;
}
.micro-track-time {
  font-family: 'Montserrat';
  font-weight: 900;
  font-size: .4em;
  color: var(--liga-chrome-text);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.micro-player-controls {
  flex: 1 1 auto;
  width: auto;
  min-width: 0;
  height: 100%;
  display: flex;
  align-items: center;
  overflow: hidden;
}
.micro-track-name {
  color: var(--liga-chrome-text);
  font-weight: bold;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  flex: 0 1 40%;
  min-width: 0;
  max-width: 40%;
}

.micro-player-buttons {
  flex: 1 1 auto;
  width: auto;
  min-width: 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  flex-wrap: nowrap;
  font-family: 'Montserrat';
  font-weight: 900;
  font-size: .8em;
  overflow: hidden;
  padding: 0 4px;
  box-sizing: border-box;
}

.micro-player-buttons .player-button {
  flex: 0 1 auto;
  min-width: 0;
}

.micro-player-buttons .player-button::part(native) {
  min-width: 34px;
  min-height: 34px;
  padding: 0 8px;
  border-radius: 11px;
}

.micro-player-buttons .player-extended-l-button::part(native) {
  min-width: 42px;
  min-height: 42px;
  border-radius: 999px;
  background: rgba(255, 129, 19, 0.18);
  border-color: rgba(255, 129, 19, 0.42);
}

.w-player {
  width: 100%;
  height: 168px;
  background: var(--liga-float-glass-bg-strong);
  border-radius: 20px;
  box-shadow: var(--liga-float-glass-shadow);
  backdrop-filter: var(--liga-float-glass-blur);
  -webkit-backdrop-filter: var(--liga-float-glass-blur);
  border: 1px solid var(--liga-float-glass-border);
  position: relative;
  overflow: hidden;
  color: var(--liga-chrome-text);
}

.w-player::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--liga-tab-bar-sheen, linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.1) 0%,
    rgba(255, 255, 255, 0.03) 50%,
    rgba(0, 0, 0, 0.04) 100%
  ));
  pointer-events: none;
  border-radius: 20px;
}

.w-track-name {
  font-family: 'NotoSans';
  font-weight: 300;
  color: var(--liga-chrome-text);
  position: absolute;
  top: 1em;
  left: 2em;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 50%;
}

.w-playlist-name {
  font-family: 'Montserrat';
  font-weight: 900;
  font-size: .8em;
  color: var(--liga-chrome-text-muted);
  position: absolute;
  top: 3em;
  left: 2em;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 50%;
}

.w-player-range {
  background: transparent !important;
  --bar-background: var(--liga-chrome-text-muted);
  --bar-background-active: var(--ion-color-orange);
  --height: 1px;
  --bar-height: 5px;
  --knob-size: 15px;
  --bar-border-radius: 15px;
  position: absolute;
  top: 3.55em;
  left: 0;
  z-index: 100;
  width: 100%;
  padding: 0 5%;
}

.w-player-buttons {
  position: absolute;
  top: auto;
  bottom: 0.55em;
  left: 0;
  padding: 0 4%;
  z-index: 100;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  flex-wrap: nowrap;
  box-sizing: border-box;
}

.w-player-buttons .player-button {
  flex: 0 1 auto;
}

.w-player-buttons .player-extended-l-button::part(native) {
  min-width: 48px;
  min-height: 48px;
  border-radius: 999px;
  background: rgba(255, 129, 19, 0.18);
  border-color: rgba(255, 129, 19, 0.42);
}

.w-service-player-buttons {
  position: absolute;
  top: 0.35em;
  right: 0.6em;
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  justify-content: flex-end;
  gap: 4px;
  z-index: 110;
}

.w-service-player-buttons .player-button::part(native) {
  min-width: 34px;
  min-height: 34px;
  border-radius: 999px;
  padding: 0;
  background: var(--liga-float-glass-bg);
}

.player-label {
  color: var(--liga-chrome-text);
}

.player-button {
  --background: transparent;
  --background-hover: transparent;
  --background-activated: transparent;
  --background-focused: transparent;
  --color: var(--liga-chrome-text);
  --box-shadow: none;
  --ripple-color: transparent;
  --padding-start: 0;
  --padding-end: 0;
  margin: 0;
  color: var(--liga-chrome-text);
  font-size: 1.05em;
  font-family: 'Montserrat';
  font-weight: 700;
  transition: transform 0.15s ease, opacity 0.15s ease;
}

.player-button::part(native) {
  min-width: 40px;
  min-height: 40px;
  padding: 0 10px;
  border-radius: 12px;
  background: var(--liga-float-glass-bg);
  border: 1px solid var(--liga-float-glass-border);
  box-shadow: var(--liga-float-glass-shadow);
  backdrop-filter: var(--liga-float-glass-blur);
  -webkit-backdrop-filter: var(--liga-float-glass-blur);
  color: var(--liga-chrome-text);
}

.player-button:active:not([disabled]) {
  transform: scale(0.96);
}

.player-button[disabled] {
  opacity: 0.42;
}

.player-button-icon {
  color: var(--liga-chrome-text) !important;
}

.player-top-icon {
  color: var(--liga-chrome-text-muted) !important;
  position: absolute;
  left: 50%;
  top: -5px;
  transform: translateX(-50%);
}

.reverse-icon {
  transform: rotateY(180deg);
}

.playlist-collapse-button {
  position: absolute;
  top: 0.85em;
  right: 4%;
  --background: transparent;
  --background-activated: transparent;
  --background-hover: transparent;
  --box-shadow: none;
  --ripple-color: transparent;
  --color: var(--liga-chrome-text);
  --padding-start: 0;
  --padding-end: 0;
  margin: 0;
  width: 40px;
  height: 40px;
  font-size: 1.15em;
  color: var(--liga-chrome-text);
  z-index: 100;
}

.playlist-collapse-button::part(native) {
  min-width: 40px;
  min-height: 40px;
  border-radius: 999px;
  padding: 0;
  background: var(--liga-float-glass-bg);
  border: 1px solid var(--liga-float-glass-border);
  box-shadow: var(--liga-float-glass-shadow);
  backdrop-filter: var(--liga-float-glass-blur);
  -webkit-backdrop-filter: var(--liga-float-glass-blur);
}

.playlist-header {
  width: 100%;
  height: 30%;
  --background: var(--liga-float-glass-bg-strong);
  --padding-top: 20px;
  --padding-bottom: 30px;
}

.player-playlist-container {
  --padding-top: 10px;
  --padding-end: 0 !important;
  width: 100%;
  height: 75%;
  --background: transparent !important;
}

.player-playlist-range {
  background: transparent !important;
}

.playlist-header-wrapper {
  padding-top: 10px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}

.playlist-header img {
  margin-left: 20px;
  height: 85%;
  width: 20%;
  border-radius: 15px;
  align-self: flex-start;
  object-fit: contain;
}

.playlist-header-text-wrapper {
  display: flex;
  flex-flow: column nowrap;
  margin-left: 20px;
  width: 65%;
  max-height: 100%;
  overflow: hidden;
}

.playlist-header-text-wrapper p {
  color: var(--liga-chrome-text-muted);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-block: 0 !important;
  font-family: 'NotoSans';
  font-weight: 300;
  font-size: .8em;
}

.playlist-header-text-wrapper h1 {
  font-weight: bold;
  align-self: flex-start;
  margin-block: 0 !important;
  color: var(--liga-chrome-text);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 85%;
  font-family: 'Montserrat';
  font-weight: 900;
  font-size: .8em;
  text-transform: uppercase;
}

.playlist-header-text-wrapper h3 {
  color: var(--liga-chrome-text-muted);
  align-self: flex-start;
  margin-block: 0 !important;
  font-size: 1em;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-block: 0 !important;
  font-family: 'Montserrat';
  font-weight: 500;
  font-size: .75em;
}

.play-list-content {
  width: 100%;
  height: 100vh;
  --background: var(--liga-page-bg) !important;
  position: relative;
  z-index: 1100;
}

.playlist-play-button-wrapper {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  max-width: 300px;
  margin-top: 8px;
}

.playlist-play-button {
  height: 42px;
  width: 30%;
  margin: 0;
  --background: transparent;
  --background-activated: transparent;
  --background-hover: transparent;
  --background-focused: transparent;
  --box-shadow: none;
  --ripple-color: transparent;
  --border-radius: 14px;
  --color: var(--liga-chrome-text);
  --padding-start: 0;
  --padding-end: 0;
  color: var(--liga-chrome-text);
  transition: transform 0.15s ease;
}

.playlist-play-button::part(native) {
  border-radius: 14px;
  background: var(--liga-float-glass-bg);
  border: 1px solid var(--liga-float-glass-border);
  box-shadow: var(--liga-float-glass-shadow);
  backdrop-filter: var(--liga-float-glass-blur);
  -webkit-backdrop-filter: var(--liga-float-glass-blur);
  color: var(--liga-chrome-text);
}

.playlist-play-button:active {
  transform: scale(0.97);
}

.playlist-play-button:first-child::part(native) {
  background: rgba(255, 129, 19, 0.18);
  border-color: rgba(255, 129, 19, 0.42);
}

.playlist-play-button .player-button-icon {
  color: var(--liga-chrome-text) !important;
}

.playlist-play-button-sm {
  width: 30% !important;
}

.player-item {
  --background: transparent;
  --color: var(--liga-chrome-text);
  color: var(--liga-chrome-text);
  width: 100%;
  border-bottom: 1px solid var(--liga-surface-border);
  font-family: 'Montserrat';
  font-weight: 500;
  font-size: .8em;
  text-transform: uppercase
}

.player-playlist {
  max-height: 60%;
  overflow: scroll;
  background: transparent;
  overflow-x: hidden;
}

.player-playlist ion-note {
  font-size: 1em;
  color: var(--liga-chrome-text-muted);
}

.player-playlist::-webkit-scrollbar {
  display: none;
}

.player-playlist::-webkit-scrollbar-track {
  display: none;
}

.fake-footer {
  height: 10vh;
}

.player-compact-container {
  width: 100%;
  height: 60px;
  position: relative;
  background: var(--liga-float-glass-bg-strong) !important;
}

.w-full-player-range {
  position: relative;
  width: 100%;
  height: 2.5em;
  margin-top: 0.5em;
}

.player-range {
  background: transparent !important;
  --bar-background: var(--liga-chrome-text-muted);
  --bar-background-active: var(--ion-color-orange);
  --height: 1px;
  --bar-height: 5px;
  --knob-size: 15px;
  --bar-border-radius: 15px;
  z-index: 100;
  width: 100%;
  padding: 0 5%;
  box-sizing: border-box;
}

.micro-range {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  max-width: 100%;
  padding: 0 10px;
  box-sizing: border-box;
}

.player-compact-controls {
  position: absolute;
  left: 5%;
  top: -10px;
  z-index: 100;
}

.player-compact-bottom-safe-area {
  width: 100%;
  height: 20px;
  background: var(--liga-float-glass-bg-strong);
}

.player-track-name {
  position: absolute;
  left: 50%;
  top: 30%;
  transform: translate(-50%, -30%);
  z-index: 100;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 40%;
}

.player-program-name {
  position: absolute;
  left: 50%;
  top: 60%;
  transform: translate(-50%, -60%);
  z-index: 100;
  font-size: 0.8em;
  color: var(--ion-color-orange);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 40%;
}

.player-current-time,
.player-total-time {
  font-family: 'Montserrat';
  font-size: 0.72em;
  font-weight: 700;
  position: absolute;
  left: 5%;
  top: 4.55em;
  transform: none;
  z-index: 90;
  line-height: 1;
  pointer-events: none;
  color: var(--liga-chrome-text-muted);
}

.player-total-time {
  right: 5% !important;
  left: unset !important;
}

.playlist-current-time,
.playlist-total-time {
  font-family: 'Montserrat';
  font-size: 0.8em;
  font-weight: bold;
  position: absolute;
  left: 5%;
  bottom: 10%;
  z-index: 120;
}

.playlist-total-time {
  right: 5% !important;
  left: unset !important;
}

.player-close-button {
  position: absolute;
  right: 5%;
  top: -10px;
  z-index: 100;
}

.player-extend-button {
  position: absolute;
  top: 15%;
  left: 5%;
  transform: translate(0, -15%);
  z-index: 100;
  font-size: 1.5em;
}

.selected-track {
  color: #FF8113;
}

.playlist-label {
  margin-inline-end: 0 !important;
  flex: 3;
}

.full-player-controls {
  width: 100%;
  --background: var(--liga-float-glass-bg-strong);
}

.player-buttons {
  display: flex;
  flex: row nowrap;
  justify-content: space-around;
  align-items: center;
  border-radius: 5px;
}

.player-timer {
  display: flex;
  flex: row nowrap;
  justify-content: space-around;
  align-items: center;
  width: 25%;
  opacity: 0.8;
  padding-left: 1em;
  padding-right: 1em;
  border-radius: 5px;
  border: 1px solid var(--liga-surface-border);
}

.player-timer ion-icon {
  font-size: 1.5em;
}

.player-timer ion-input {
  font-family: 'Montserrat';
  color: var(--liga-chrome-text);
}

.player-wrapper {
  --background: var(--liga-float-glass-bg-strong) !important;
}

ion-tab-bar {
  height: auto;
}

/* iOS Safari / Chrome iOS: строка поиска не входит в safe-area-inset-bottom. */
html.plt-mobileweb {
  --liga-browser-chrome-bottom: 56px;
}
@media (max-width: 768px) and (hover: none) and (pointer: coarse) {
  html:not(.plt-hybrid):not(.plt-capacitor) {
    --liga-browser-chrome-bottom: 56px;
  }
}
@media (display-mode: standalone), (display-mode: fullscreen) {
  html.plt-mobileweb,
  html:not(.plt-hybrid):not(.plt-capacitor) {
    --liga-browser-chrome-bottom: 0px;
  }
}

/* Floating glass pill bottom bar */
.modern-tab-bar {
  --background: var(--liga-float-glass-bg-strong, rgba(28, 28, 32, 0.72)) !important;
  --color: var(--liga-chrome-text-muted, rgba(255, 255, 255, 0.62));
  --border: none;
  /* Один inset снизу через margin; Ionic host safe-area padding отключаем */
  --padding-bottom: 0px;
  height: auto;
  min-height: 64px;
  padding: 8px 10px !important;
  margin: 0 14px calc(10px + env(safe-area-inset-bottom, 0px) + var(--liga-browser-chrome-bottom, 0px));
  border-radius: 999px;
  border: 1px solid var(--liga-float-glass-border, rgba(255, 255, 255, 0.14));
  background: var(--liga-float-glass-bg-strong, rgba(28, 28, 32, 0.72)) !important;
  backdrop-filter: var(--liga-float-glass-blur, blur(18px));
  -webkit-backdrop-filter: var(--liga-float-glass-blur, blur(18px));
  box-shadow: var(--liga-float-glass-shadow, 0 8px 28px rgba(0, 0, 0, 0.28));
  position: relative;
  overflow: hidden;
  contain: layout style;
  z-index: 11;
}

.modern-tab-bar::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: var(--liga-tab-bar-sheen, linear-gradient(
    160deg,
    rgba(255, 255, 255, 0.1) 0%,
    rgba(255, 255, 255, 0.03) 45%,
    rgba(0, 0, 0, 0.08) 100%
  ));
  pointer-events: none;
}

.modern-tab-button {
  --color: var(--liga-chrome-text-muted, rgba(255, 255, 255, 0.62));
  --color-selected: var(--liga-chrome-text, #ffffff);
  --background: transparent;
  --background-selected: transparent;
  --background-focused: transparent;
  color: var(--liga-chrome-text-muted, rgba(255, 255, 255, 0.62));
  border-radius: 999px;
  margin: 0 2px;
  padding: 6px 10px;
  transition: background 0.2s ease, color 0.2s ease;
  position: relative;
  overflow: hidden;
  min-height: 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.modern-tab-button::before {
  content: '';
  position: absolute;
  inset: 2px;
  background: var(--liga-tab-btn-hover, rgba(255, 255, 255, 0.1));
  opacity: 0;
  transition: opacity 0.2s ease;
  border-radius: 999px;
}

.modern-tab-button:hover::before,
.modern-tab-button.selected::before {
  opacity: 1;
}

.modern-tab-button.selected {
  transform: none;
  box-shadow: none;
}

.tab-icon-wrapper {
  position: relative;
  z-index: 2;
  margin-bottom: 2px;
  transition: transform 0.2s ease;
}

.modern-tab-button.selected .tab-icon-wrapper {
  transform: none;
}

.tab-icon-wrapper ion-icon {
  font-size: 22px;
  transition: color 0.2s ease;
  color: var(--liga-chrome-text-muted, rgba(255, 255, 255, 0.62));
}

.modern-tab-button.selected .tab-icon-wrapper ion-icon {
  color: var(--ion-color-orange);
  filter: none;
}

.tab-label {
  font-size: 10px;
  font-weight: 600;
  font-family: 'Montserrat', sans-serif;
  text-transform: none;
  letter-spacing: 0.02em;
  position: relative;
  z-index: 2;
  transition: color 0.2s ease, opacity 0.2s ease;
  opacity: 0.9;
  color: var(--liga-chrome-text-muted, rgba(255, 255, 255, 0.62));
}

.modern-tab-button.selected .tab-label {
  opacity: 1;
  color: var(--ion-color-orange);
}

@media (max-width: 768px) {
  .modern-tab-bar {
    margin: 0 10px calc(8px + env(safe-area-inset-bottom, 0px) + var(--liga-browser-chrome-bottom, 0px));
    padding: 6px 8px !important;
    min-height: 60px;
  }

  .modern-tab-button {
    margin: 0 1px;
    padding: 5px 6px;
    min-height: 46px;
  }

  .tab-icon-wrapper ion-icon {
    font-size: 20px;
  }

  .tab-label {
    font-size: 9px;
  }
}

/* Веб: нижнее меню по центру */
.modern-tab-bar.tab-bar-web {
  min-width: 360px;
  max-width: 520px;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: calc(12px + env(safe-area-inset-bottom, 0px) + var(--liga-browser-chrome-bottom, 0px));
  min-height: 64px;
  padding: 8px 14px !important;
  border-radius: 999px;
}

.modern-tab-bar.tab-bar-web .modern-tab-button {
  min-height: 48px;
  padding: 6px 12px;
  margin: 0 2px;
  border-radius: 999px;
}

.modern-tab-bar.tab-bar-web .modern-tab-button::before {
  border-radius: 999px;
}

.modern-tab-bar.tab-bar-web .tab-icon-wrapper {
  margin-bottom: 2px;
}

.modern-tab-bar.tab-bar-web .tab-icon-wrapper ion-icon {
  font-size: 20px;
}

.modern-tab-bar.tab-bar-web .tab-label {
  font-size: 10px;
  letter-spacing: 0.03em;
  text-transform: none;
  font-weight: 500;
}

.modern-tab-bar.tab-bar-web .modern-tab-button.selected {
  transform: none;
  box-shadow: none;
}

.modern-tab-bar.tab-bar-web .modern-tab-button.selected .tab-icon-wrapper {
  transform: none;
}

/* Legacy styles for compatibility */
.release-tab-button {
  --color-selected: var(--ion-color-orange);
}

.release-tab-button ion-icon {
  font-size: 2.5em !important;
}

.release-tab-button ion-badge {
  font-family: 'Montserrat';
}

.player-extended-container {
  width: 100%;
  height: 50px;
  background: var(--liga-float-glass-bg-strong) !important;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-around;
  align-items: center;
  padding-top: 1em;
  padding-bottom: 1em;
}

.player-extended-l-button {
  font-size: 1.35em;
}

.player-extended-sm-button {
  font-size: 1em;
}

html.liga-theme-light .w-player-buttons .player-extended-l-button::part(native),
html.liga-theme-light .micro-player-buttons .player-extended-l-button::part(native),
html.liga-theme-light .playlist-play-button:first-child::part(native) {
  background: rgba(235, 89, 82, 0.14);
  border-color: rgba(235, 89, 82, 0.38);
}

.player-extended-xsm-button {
  font-size: 0.7em;
}

.player-extended-minus-seconds {
  position: relative;
}

.player-extended-minus-seconds::before {
  content: "-15s";
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
}

.player-extended-add-seconds {
  position: relative;
}

.player-extended-add-seconds::before {
  content: "+15s";
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
}

.button-top-label {
  font-size: 0.8em;
  font-weight: bold;
  position: absolute;
  top: 0;
  left: 0;
}

.player-settings-container {
  width: 100%;
  height: 100px;
  background: var(--liga-float-glass-bg-strong) !important;
}

.player-settings-container ion-item {
  --background: transparent !important;
  --color: var(--liga-chrome-text);
}

.player-settings-container ion-toggle {
  --background-checked: var(--ion-color-orange);
  --background: #5a5a5a;
  --handle-background-checked: white;
}

.menu-badge {
  --background: var(--ion-color-orange);
  --color: white;
  font-family: 'Montserrat',
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}

.access-denied-card-modal {
  --background: rgba(67, 67, 67, 0.5) !important;
  --backdrop-opacity: 0.3;
}

.access-denied-card-container {
  display: flex;
  justify-content: center;
  align-content: center;
  flex-flow: column;
  height: 100vh;
}

.access-denied-card-container ion-card {
  padding: 20px;
  max-height: 90%;
  overflow: scroll;
  --background: #1f1f1f !important;
}

.access-denied-card-container ion-card-title {
  color: white;
  font-weight: bold;
  font-size: 1.8em;
  letter-spacing: 0.07em;
}

.access-denied-card-container ion-card-content {
  color: rgba(255, 255, 255, 0.5);
  font-weight: bold;
  font-size: 1em;
  letter-spacing: 0.07em;
}

.access-denied-card-img {
  display: flex;
  justify-content: center;
}

.access-denied-card-img img {
  width: 70%;
}

.access-denied-btn-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.access-denied-btn-container ion-button {
  --background: var(--ion-color-orange);
  --background-activated: var(--ion-color-orange-tint);
  width: 280px;
  height: 50px;
  font-family: 'Montserrat',
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-weight: bold;
  --border-radius: 14px;
}

.download-progress {
  font-size: 3em !important;
  color: var(--ion-color-orange) !important;
}

.play-now-container {
  --background: transparent;
  color: white;
  --border-radius: 15px;
}

.play-now-container ion-content {
  --background: transparent;
}

.play-now-container ion-item {
  --background: rgba(67, 67, 67, 0.7);
}

.play-now-container ion-button {
  --background: var(--ion-color-orange);
  --background-activated: var(--ion-color-orange-tint);
  width: 80%;
  height: 50px;
  font-family: 'Montserrat';
  font-weight: bold;
  --border-radius: 14px;
}

.play-now-container .cancel-button {
  --background: #eb445a !important;
  --background-activated: #e95e70 !important;
  margin-top: 2em;
}

.play-now-container ion-label {
  font-family: 'Montserrat',
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-weight: bold;
  color: white;
}

.play-now-container div {
  width: 100%;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}

/* Animation */
.extended-player-enter-active {
  max-height: 50px;
  transition: max-height 0.4s ease-out;
}

.extended-player-enter-from {
  max-height: 0;
}

.extended-player-leave-active {
  opacity: 0;
  transition: opacity 0.1s ease-out;
}

/* Animation */
.playlist-player-enter-active {
  max-height: 100vh;
  transition: max-height 0.4s ease-out;
}

.playlist-player-enter-from {
  max-height: 0;
}

.playlist-player-leave-active {
  opacity: 0;
  transition: opacity 0.1s ease-out;
}

/* Согласие с политикой — fixed overlay (все платформы) */
.privacy-consent-overlay {
  position: fixed;
  inset: 0;
  z-index: 100000;
  display: flex;
  flex-direction: column;
  background: var(--ion-background-color, #111);
  padding-top: env(safe-area-inset-top, 0px);
  box-sizing: border-box;
}

.privacy-consent-sheet {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  width: 100%;
  max-width: 520px;
  margin: 0 auto;
}

.privacy-consent-header {
  flex-shrink: 0;
  padding: 1rem 1.25rem 0.75rem;
  border-bottom: 1px solid var(--liga-float-glass-border, rgba(255, 255, 255, 0.12));
}

.privacy-consent-title {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--liga-chrome-text, #fff);
  letter-spacing: 0.02em;
}

.privacy-consent-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 1.25rem;
}

.privacy-consent-text {
  margin: 0 0 1em;
  line-height: 1.5;
  color: var(--liga-chrome-text, #fff);
}

.privacy-consent-link {
  color: var(--ion-color-orange);
  text-decoration: underline;
}

.privacy-consent-footer {
  flex-shrink: 0;
  padding: 0.75rem 1.25rem;
  padding-bottom: max(1rem, env(safe-area-inset-bottom, 0px));
  border-top: 1px solid var(--liga-float-glass-border, rgba(255, 255, 255, 0.12));
  background: var(--ion-background-color, #111);
}

.privacy-consent-accept-btn {
  --background: var(--ion-color-orange);
  --background-activated: var(--ion-color-orange-tint);
  --background-disabled: rgba(235, 89, 82, 0.4);
  margin: 0;
  min-height: 48px;
  font-weight: 700;
  text-transform: none;
}

:deep(.update-prompt-modal) ion-toolbar {
  --background: var(--liga-float-glass-bg-strong);
  --color: var(--liga-chrome-text);
}
:deep(.update-prompt-modal) .update-prompt-text {
  margin: 0 0 1.25rem;
  line-height: 1.5;
  color: var(--liga-chrome-text);
}
:deep(.update-prompt-modal) .update-prompt-update-btn {
  --background: var(--ion-color-orange);
  --background-activated: var(--ion-color-orange-tint);
  margin-top: 0.5rem;
}
:deep(.update-prompt-modal) .update-prompt-later-btn {
  --color: var(--liga-chrome-text-muted);
  margin-top: 0.35rem;
}

:deep(.appearance-picker-modal) {
  --ion-color-primary: var(--ion-color-orange);
  --ion-color-primary-contrast: #fff;
}
:deep(.appearance-picker-modal) ion-toolbar {
  --background: var(--liga-float-glass-bg-strong);
  --color: var(--liga-chrome-text);
  --border-width: 0;
}
:deep(.appearance-picker-modal) ion-title {
  color: var(--liga-chrome-text);
}
:deep(.appearance-picker-modal) .appearance-picker-header-later {
  --color: var(--liga-chrome-text-muted);
  --color-activated: var(--liga-chrome-text);
  --background: transparent;
  --background-activated: transparent;
  --ripple-color: transparent;
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0.01em;
}
:deep(.appearance-picker-modal) .appearance-picker-content {
  --background: var(--liga-page-bg);
}
:deep(.appearance-picker-modal) .appearance-picker-text {
  margin: 0 0 1.25rem;
  line-height: 1.5;
  color: var(--liga-chrome-text-muted);
}
:deep(.appearance-picker-modal) .appearance-picker-btn {
  --background: var(--liga-float-glass-bg);
  --background-activated: rgba(235, 89, 82, 0.28);
  --background-focused: var(--liga-surface);
  --background-hover: var(--liga-surface);
  --color: var(--liga-chrome-text);
  --border-radius: 14px;
  --border-width: 1px;
  --border-style: solid;
  --border-color: var(--liga-float-glass-border);
  --box-shadow: none;
  --padding-top: 14px;
  --padding-bottom: 14px;
  margin: 0 0 10px;
  font-weight: 650;
  text-transform: none;
  letter-spacing: 0.01em;
}
:deep(.appearance-picker-modal) .appearance-picker-later-btn {
  --color: rgba(255, 255, 255, 0.7);
  --color-activated: #fff;
  --background: transparent;
  --box-shadow: none;
  margin-top: 0.25rem;
  text-transform: none;
  font-weight: 600;
}

/* Выбор канала техподдержки (Telegram / VK) */
:deep(.support-channel-modal) ion-toolbar {
  --background: var(--liga-float-glass-bg-strong);
  --color: var(--liga-chrome-text);
  --border-color: var(--liga-float-glass-border);
  backdrop-filter: var(--liga-float-glass-blur);
  -webkit-backdrop-filter: var(--liga-float-glass-blur);
}
:deep(.support-channel-modal) .support-channel-content {
  --background: var(--liga-page-bg);
}
:deep(.support-channel-modal) .support-channel-hint {
  margin: 0.5rem 0 1.25rem;
  color: var(--liga-chrome-text-muted);
  font-size: 0.95rem;
}
:deep(.support-channel-modal) .support-channel-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
  align-items: stretch;
  max-width: 420px;
  margin: 0 auto;
}
:deep(.support-channel-modal) .support-channel-btn {
  flex: 1 1 140px;
  min-height: 120px;
  max-width: 180px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 1rem;
  border: 1px solid var(--liga-float-glass-border);
  border-radius: 12px;
  background: var(--liga-float-glass-bg-strong);
  color: var(--liga-chrome-text);
  box-shadow: var(--liga-float-glass-shadow);
  backdrop-filter: var(--liga-float-glass-blur);
  -webkit-backdrop-filter: var(--liga-float-glass-blur);
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: background 0.15s ease, border-color 0.15s ease;
  text-align: center;
}

:deep(.support-channel-modal) .support-channel-btn--primary {
  color: #1b1408;
  background: linear-gradient(135deg, #ffd08a 0%, #f59e0b 100%);
  border-color: transparent;
}
:deep(.support-channel-modal) .support-channel-btn:active {
  background: var(--liga-surface);
}
:deep(.support-channel-modal) .support-channel-btn--primary:active {
  background: linear-gradient(135deg, #ffc56e 0%, #e8900a 100%);
}
:deep(.support-channel-modal) .support-channel-icon-wrap {
  width: 56px;
  height: 56px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
}
:deep(.support-channel-modal) .support-channel-icon-wrap--wide img {
  object-fit: contain;
  max-width: 48px;
  max-height: 48px;
  width: 48px;
  height: 48px;
}

:deep(.support-channel-modal) .support-channel-icon-wrap img {
  width: 56px;
  height: 56px;
  max-width: 56px;
  max-height: 56px;
  object-fit: contain;
  display: block;
}
:deep(.support-channel-modal) .support-channel-label {
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.2;
  color: inherit;
}
:deep(.support-channel-modal) .support-channel-btn--primary .support-channel-label {
  color: #1b1408;
}
:deep(.support-channel-modal) .support-channel-icon-wrap ion-icon {
  font-size: 32px;
  color: inherit;
}
</style>